export default {
  smartMirrorCamera: {
    title: 'Wie möchtest du SmartMirror verwenden?',
    subtitle:
      'Nutze die Kamera dieses Computers, verbinde ein iPhone oder starte ohne SmartMirror.',
    computer: 'Computerkamera verwenden',
    iphone: 'iPhone als Kamera verbinden',
    ios_only: 'Die Telefonverbindung ist derzeit nur unter iOS verfügbar.',
    without: 'Ohne SmartMirror fortfahren',
    sending: 'Benachrichtigung wird gesendet…',
    unavailable:
      'Die iPhone-Verbindung ist für dieses Training nicht verfügbar.',
    no_device:
      'Für dieses Konto wurde kein iPhone mit aktivierten Benachrichtigungen gefunden.',
    send_error:
      'Die Benachrichtigung konnte nicht gesendet werden. Bitte versuche es erneut.',
    waiting_title: 'Verbindung auf dem iPhone abschließen',
    waiting_body:
      'Öffne die Stretchme-Benachrichtigung auf deinem iPhone. Falls sie fehlt, scanne den Code unten mit der iPhone-Kamera.',
  },
  android_promo_banner: {
    title: 'Stretchme.app',
    desc: 'stretching & yoga',
    install: 'Installieren',
    open: 'App öffnen',
  },
  i_have_voucher: 'Ich habe einen Werbecode ',
  have_voucher: 'einen Gutschein haben?',
  voucher_placeholder: 'Coupon Code',
  send_voucher: 'Schicken',
  verification_code: 'Kod weryfikacyjny',
  VOUCHER_CODE: 'Kod vouchera',
  DO_YOU_HAVE_VOUCHER: 'Chce skorzystać z vouchera',
  voucher_activated: 'Ein Gutschein wurde aktiviert',
  VOUCHER_ACCESS: 'Gutscheinzugang',
  NO_ACTIVE_SUBSCRIPTION: 'Kein aktives Abonnement',
  voucher_activated_desc:
    'Wir freuen uns, dass Sie sich uns als Business -Kunden angeschlossen haben.Ihre Partnerschaft ist für uns wertvoll.Nach Abschluss des Vorgangs die Appstore / Google Play -Abonnements abschließen',
  voucher_activated_label: 'Nächste',
  voucher_code_invalid: 'Falscher Code',
  voucher_code_invalid_desc: 'Geben Sie den Code erneut ein',
  voucher_code_invalid_label: 'OK',
  personalized_plan: {
    title: 'Für dich ausgewählt 🧘🏻',
    subtitle:
      'Auf Grundlage deiner Präferenzen haben wir einen empfohlenen wöchentlichen Trainingsplan erstellt. Für optimale Ergebnisse solltest du zwei Tage pro Woche Entspannung, Meditation oder Faszientraining widmen.',
    completed_title: 'Dein Plan ist abgeschlossen 🏆',
    completed_subtitle: 'Du hast alle Trainings in diesem Plan abgeschlossen.',
    completed_question:
      'Möchtest du mit demselben Ziel fortfahren oder die Kriterien ändern?',
    continue_same: 'Mit diesem Ziel fortfahren',
    change_criteria: 'Kriterien ändern',
    generating: 'Plan wird erstellt…',
    save_criteria: 'Speichern und neuen Plan erstellen',
    generation_error:
      'Der neue Plan konnte nicht erstellt werden. Versuche es gleich noch einmal.',
    criteria: {
      goal: 'Trainingsziel',
      experience: 'Erfahrungsniveau',
      experience_0: 'Ich fange von vorne an',
      experience_1: 'Anfänger',
      experience_2: 'Mittelstufe',
      experience_3: 'Fortgeschritten',
      experience_4: 'Sehr fortgeschritten',
      flexibility: 'Beweglichkeitsniveau',
      flexibility_no: 'Niedrig',
      flexibility_little: 'Mittel',
      flexibility_yes: 'Hoch',
      frequency: 'Häufigkeit',
      frequency_value: '{{count}} Training(s) pro Woche',
    },
    next: 'Nächstes Training',
    completed: 'Abgeschlossen',
    step: 'Schritt {{number}}',
    completed_step: 'Abgeschlossener Schritt {{number}}',
  },
  finish_session_thanks: {
    position_to_improve: 'Eine Position zur Verbesserung',
    most_errors_position: 'Die meisten Fehler traten in dieser Position auf:',
    undetected_warning:
      'In mindestens einer Position konnten wir deinen Körper die meiste Zeit nicht erkennen. Stelle dich beim nächsten Mal genau wie die Trainerin in einem gut beleuchteten Raum auf und achte darauf, dass dein ganzer Körper sichtbar ist. Dies beeinflusst dein Endergebnis.',
    tips_for_you: 'Tipps für Sie:',
    level_1_message: 'Toller Start!',
    level_2_message: 'Du bist auf dem richtigen Weg!',
    level_3_message: 'Wir sind beeindruckt!',
    level_4_message: 'Das machst du toll!',
    level_5_message: 'Du bist ein Dehnungsmeister!',
    congratulation: 'Glückwunsch!',
    your_score: 'Ihr Ergebnis ist:',
    best_score: 'Bestes Ergebnis:',
    first_category_tips: {
      _1: 'x',
      _2: 'x',
      _3: 'x',
      _4: 'x',
      _5: 'x',
    },
    second_category_tips: {
      _1: 'x',
      _2: 'x',
      _3: 'x',
      _4: 'x',
      _5: 'x',
    },
    third_category_tips: {
      _1: 'x',
      _2: 'x',
      _3: 'x',
      _4: 'x',
      _5: 'x',
    },
  },
  COMPANY_NAME: 'Name der Firma',
  MINIMAL_CHAR_LONG: 'Mindestlänge 12 Zeichen',
  PASS_TO_SHORT: 'Zu kurz (12 Zeichen)',
  CAPITAL_LETTER_REQUIRED: 'Großbuchstaben verwenden',
  LOWERCASE_REQUIRED: 'Kleinbuchstaben verwenden',
  NUMBER_REQUIRED: 'Zahlen erforderlich',
  SPECIAL_CHAR_REQUIRED: 'Sonderzeichen erforderlich',
  QUESTIONS_AND_ANSWERS: {
    QUESTION_1: 'Dlaczego StretchMe?',
    QUESTION_2: 'Co to jest i jak działa natychmiastowa informacja zwrotna?',
    QUESTION_3: 'Jakie treningi znajdę w StretchMe?',
    QUESTION_4:
      'Czy muszę mieć doświadczenie w rozciąganiu, żeby korzystać ze StretchMe?',
    QUESTION_5: 'Czy mogę bezpłatnie zapoznać się z oferowanymi treningami?',
    QUESTION_6: 'Jak działa subskrypcja?',
    QUESTION_7: 'Jakie są możliwości płatności?',
    QUESTION_8: 'Na jakich urządzeniach mogę korzystać ze StretchMe?',
    QUESTION_9: 'Czego potrzebuję do treningów?',
    QUESTION_10: 'Kto prowadzi treningi?',
    QUESTION_11: 'Czy moje treningi są nagrywane?',
    ANSWER_1:
      'Stretchme to platforma treningowa inna niż wszystkie! Dzięki naszym autorskim treningom szpagat, sznurek oraz mostek będzie w zasięgu ręki. Po przeanalizowaniu indywidualnych celów oraz formularza wstępnego, Stretchme dobierze program treningowy i będzie go automatycznie dostosowywać w oparciu o Twoje postępy. Dodatkowo w czasie treningu nasz autorski algorytm będzie śledził położenie Twojego ciała i dawał informacje na temat poprawności wykonywanych przez Ciebie ćwiczeń.',
    ANSWER_2:
      'Podczas treningu aktywnie wykorzystywana jest kamera w telefonie/tablecie użytkownika. Dzięki temu, ćwiczący w czasie rzeczywistym może korygować swoje pozy. Pozwala to na zapewnienie poprawnego wykonywania ćwiczeń, co zwiększa bezpieczeństwo użytkownika. Natychmiastowa informacja zwrotna działa w oparciu o algorytmy sztucznej inteligencji, Żeby w pełni wykorzystać potencjał StretchMe potrzebujesz tylko jednego urządzenia!',
    ANSWER_3_1:
      'Na naszej platformie Stretchme znajdziesz wszystkie treningi oferowane przez studio:',
    ANSWER_3_2:
      'autorskie zajęcia rozciągająco-wzmacniające zwiększające mobilność ciała oraz przygotowujące do szpagatów, sznurków oraz mostków',
    ANSWER_3_3:
      'treningi Stretch Wheel skupiające się w głównej mierze na rozciągnięciu oraz wzmocnieniu kręgosłupa, pomagające wypracować poprawną postawę ciała (podczas treningów wykorzystujemy koło do jogi)',
    ANSWER_3_4:
      'praktyki jogowe, które pomogą Ci lepiej poznać swoje ciało oraz jego możliwości',
    ANSWER_3_5:
      'treningi RelaxStretch i StretchFlow dzięki, którym odpoczniesz i zrelaksujesz się po ciężkim i stresującym dniu',
    ANSWER_4:
      'Nie musisz mieć doświadczenia. Program treningowy Stretchme oferuje treningi na każdym poziomie zaawansowania, dostosowane do Twojego trybu życia oraz potrzeb. Nasi trenerzy będą towarzyszyć Ci podczas Twojej przygody z rozciąganiem i pomogą osiągnąć zamierzone cele.',
    ANSWER_5:
      'Tak! Oferujemy 3 dni za darmo, podczas których uzyskasz pełny dostęp do naszej biblioteki treningowej i ocenisz czy Stretchme jest dla Ciebie.',
    ANSWER_6_1: 'Subskrypcja StretchMe możliwa jest na okres:',
    ANSWER_6_2: 'miesiąca,',
    ANSWER_6_3: '3 miesięcy,',
    ANSWER_6_4: 'roku.',
    ANSWER_6_5:
      'Subskrypcja jest automatycznie odnawialna, zatem w przypadku braku chęci kontynuacji, należy zrezygnować z niej w aplikacji. StretchMe oferuje 3 dniowy okres próbny.',
    ANSWER_7:
      'Płatność możliwa jest w aplikacji StretchMe. Wówczas, sposobem płatności jest ten, który użytkownik ma połączony z swoim AppleID. Za dostęp do platformy internetowej możliwe jest także wykorzystanie płatności kartą poprzez stronę stretchme.app',
    ANSWER_8:
      'Z StretchMe można w pełni korzystać na urządzeniach mobilnych z systemem IOS. Możliwe jest także jedynie odtwarzanie treningów na platformie internetowej, dostępnej z każdej przeglądarki.',
    ANSWER_9:
      'Do większości naszych treningów potrzebujesz jedynie maty oraz wolnej przestrzeni. W przypadku niektórych treningów sporym ułatwieniem będzie posiadanie kostek, gum oporowych oraz koła do jogi. Jeżeli nie posiadasz obecnie tych sprzętów nie martw się, programy treningowe zostaną w pełni dostosowane do posiadanych przez Ciebie sprzętów.',
    ANSWER_10_1:
      'Wszystkie treningi Stretchme prowadzone są przez certyfikowanych nauczycieli, których na co dzień możesz spotkać w naszym studio stacjonarnym. Chcesz ich poznać?',
    ANSWER_10_2: 'Monika Stasiak',
    ANSWER_10_3:
      'Trenerka autorskiego programu StretchMe, inspirowanego gimnastyką, tańcem i jogą. Stretching jest nieodłączna częścią jej osobowości, tak jak pozytywne nastawienie do świata, wdzięczność, radość, otwartość umysłu. Uważa, że piękne chwile nas nie spotykają, piękne chwile trzeba tworzyć. Mówi, ze nie jest „normalna” w końcu żyje z rozciągania, który większości kojarzy się z bólem. Ona odczarowuje ten ból. Pokaże, że rozciąganie stanie się najprzyjemniejszą częścią Twojego dnia, tygodnia, po prostu wolnego czasu.',
    ANSWER_10_4: 'Natalia Zagumna',
    ANSWER_10_5:
      'Absolwentka Akademii Wychowania Fizycznego w Warszawie na kierunku fizjoterapia, certyfikowany trener personalny, pasjonatka ruchu ludzkiego ciała. Od najmłodszych lat związana ze sportem, teatrem oraz akrobatyką i tańcem. Nieustannie poszukująca nowych form wyrażania siebie. Na co dzień uczy ludzi ruchu ale jej celem jest pokazać jak piękne i wystarczające potrafi być ludzkie ciało.',
    ANSWER_10_6: 'Nikola Chmiel',
    ANSWER_10_7:
      'Była tancerka, certyfikowana nauczycielka jogi. To właśnie taniec i joga sprawiły, że pokochała rozciąganie. Dzięki nim odkryła siebie i swoją największą miłość, czyli uczenie innych. Jej zajęcia są dla każdego, prowadzone prosto z serca.',
    ANSWER_11:
      'Tylko, jeśli wyrazisz na to zgodę przed daną sesją. Jeśli tak, to dane z Twojego treningu będą użyte do poprawiania pracy algorytmu uczenia maszynowego. Podczas sesji masz możliwość wykonania zdjęć w danych pozycjach, aby móc obserwować i mierzyć swoje postępy',
    ANSWER_10_8: 'Karolina Bigaj',
    ANSWER_10_9:
      'Karolina jest trenerką rozciągania, która odkryła swoją pasję do tańca i rozciągania poprzez pole dance. Rozpoczęła treningi rozciągania pod czujnym okiem Moniki, aby doskonalić swoje umiejętności. Dzięki systematycznemu podejściu i wytrwałości jej pasja zamieniła się w miłość do rozciągania, którą teraz przekazuje innym podczas swoich zajęć. Karolina docenia chęć do pracy i pozytywne podejście u swoich uczestników. Jej celem jest nie tylko pomoc w rozwijaniu elastyczności, ale także inspirowanie innych do odkrywania i rozwijania ich potencjału. Dołącz do treningów Karoliny i poczuj korzyści z rozciągania, wzbogacając swoje ciało i umysł pozytywną atmosferą.',
    ANSWER_10_10: 'Hanna Wlaz',
    ANSWER_10_11:
      'Hanna ukończyła z wyróżnieniem Państwową Szkołę Baletową w Poznaniu. Jeszcze będąc w szkole, brała udział w krajowych i międzynarodowych konkursach baletowych oraz występowała w spektaklach repertuarowych w Teatrze Wielkim w Poznaniu. Po otrzymaniu dyplomu tancerki, dołączyła do baletu Teatru Wielkiego, gdzie tańczyła w spektaklach baletowych i operowych, pogłębiając swoją wiedzę i kompetencje zarówno w tańcu, jodze, pilatesie, jak i rozciąganiu. Hanna z entuzjazmem dzieli się swoją wiedzą o balecie, starając się pokazać, że nauka tańca klasycznego może być ciekawą przygodą nie tylko dla dzieci, ale także dla dorosłych. Jej celem jest zachęcanie do aktywności fizycznej ludzi w każdym wieku oraz pokazanie, że ćwiczenia mogą być źródłem radości i sposobem na lepsze samopoczucie.',
  },
  QUESTIONS: 'Fragen und Antworten',
  BUSINESS_REGISTRATION2: 'Registrierung von Geschäftskunden',
  BUSINESS_LOGIN: 'Anmeldung bei Geschäftskunden',
  BUSINESS_LOGIN_SUBTITLE:
    'Wenn Sie bereits unser Geschäftskunden sind, können Sie sich jetzt anmelden oder Ihr Abonnement mit einem Gutschein erweitern',
  BUSINESS_REGISTER: 'Registrierung von Geschäftskunden',
  BUSINESS_REGISTER_SUBTITLE:
    'Wenn Sie ein neuer Business -Kunde sind, können Sie sich jetzt registrieren und unsere Dienste nutzen.Wenn Sie einen Gutschein haben, können Sie ihn während der Registrierung verwenden.Wenn Sie bereits unser Geschäftskunden sind, können Sie sich auch anmelden und Ihr Abonnement erweitern',
  TRAIN_WITH_US: 'Trainiere mit Stretchme',
  SET_CONSENT: 'Bitte erteilen Sie die folgenden Zustimmungen, um fortzufahren',
  OWN_RISK: 'Ich trainiere auf eigene Gefahr',
  ALLOW_ML:
    'Ich stimme der Verarbeitung meiner Daten zur Verbesserung von Machine-Learning-Modellen zu',
  NEXT: 'weiter',
  COOKIE_BANNER: {
    title: 'Cookies - Helfen Sie uns, besser zu werden',
    body: 'Sie können entscheiden, welche Cookies Sie verwenden möchten, indem Sie die entsprechenden Optionen unten auswählen. Denken Sie daran, dass Ihre Auswahl die Funktionalität der Anwendung beeinflussen kann.',
    required_only: 'Notwendig',
    analytics: 'Funktionell',
    marketing: 'Geschäft',
    manage_cookie: 'Cookies verwalten',
  },
  NEU: `Neu`,
  COOKIE_MANAGER: 'Cookie-Manager',
  BESONDERS_BELIEBT: `Besonders Beliebt`,
  BEISPIEL_ANSEHEN: `Beispiel ansehen`,
  POSE_COMPARISON: `Pose Comparison`,
  VERGLEICHE_DEINE_POSEN_DIREKT: `Vergleiche deine Posen direkt nach der Session mit dem Video.`,
  SMART_MIRROR: `Smart Mirror`,
  VERBESSERE_DICH_DIREKT_IN_DER: `Verbessere dich direkt in der Session durch visuelles Feedback.`,
  SMARTMIRROR_VERBINDEN: `SmartMirror verbinden`,
  MEHR_BER: `Mehr über`,
  NON_FULLSCREEN: `Non-Fullscreen`,
  BY: `by`,
  F_R_DICH: `Für dich`,
  VISUELLES_FEEDBACK_SO_FUNKTI: `Visuelles Feedback – So funktioniert's`,
  MEHR_ERFAHREN: `Mehr erfahren`,
  CENTER_RIGHT: `center right`,
  BEST_TIGEN: `Bestätigen`,
  SEND_CODE_AGAIN: 'Wyślij kod ponownie',
  ZUR_CK_ZUM_LOGIN: `Zurück zum Login`,
  PASSWORT_ZUR_CKSETZEN: `Passwort Zurücksetzen`,
  IMPRESSUM: `Impressum`,
  DATENSCHUTZERKL_RUNG: `Datenschutzerklärung`,
  COOKIE_POLICY: `Cookie Policy`,
  NUTZUNGSBEDINGUNGEN: `Nutzungsbedingungen`,
  LINKS_FOOTER: `links.footer`,
  LINKS_FOOTERDARKSOLID: `links.footerDarkSolid`,
  LINKS_FOOTERDARKTRANSPARENT: `links.footerDarkTransparent`,
  SERIE: `Serie (`,
  BILDER1: `Bilder)`,
  ABLEHNEN: `Ablehnen`,
  WE_MAKE_YOGA: `We make Yoga`,
  ABOUT_YOU: `about You`,
  HOME: `Home`,
  KURSE: `Kurse`,
  MEIN_BEREICH: `Mein Bereich`,
  MEIN_ACCOUNT: `Mein Account`,
  WIE_FUNKTIONIERT_S: `Wie funktioniert's?`,
  AUSLOGGEN: `Ausloggen`,
  HALLO: `Hallo`,
  NOCH: `Noch`,
  TAGE: `Tage`,
  FINAL: `final`,
  DAY: `day`,
  TAG: `Tag #`,
  INTRO: `1 - Intro`,
  MEHR_BER_DIE_POSE: `Mehr über die Pose`,
  MIT_HILFE_DER_POSE_COMPARISON: `Mit Hilfe der Pose Comparison bieten wir Dir Dein privates
            Yoga-Tagebuch, auf dem nur Du Zugriff hast. Im Beispiel kannst Du
            sehen was hinter der Pose Comparison steckt. Starte jetzt Deine
            erste Session, um Deine persönliche Gallerie zu füllen. So kannst Du
            die einzelnen Posen mit der Lehrerin vergleichen und Deine
            Fortschritte beobachten.`,
  KEINE_SORGE_DEINE_BILDER_SIN: `Keine Sorge – Deine Bilder sind privat`,
  SORRY: `Sorry!`,
  DA_HAT_WOHL_ETWAS_NICHT_FUNKTI: `Da hat wohl etwas nicht funktioniert!`,
  MELDE_DICH_GERNE_BEI_UNS_UND_W: `Melde dich gerne bei uns und wir helfen dir weiter:`,
  QR_CODE_ZUM_EINLOGGEN: `QR Code zum Einloggen`,
  BITTE_SCANNE_DEN_CODE_MIT_DER: `Bitte scanne den Code mit der`,
  YUUYOGA_SMARTPHONE_APP: `YuuYoga Smartphone App`,
  UM_ZUGANG_ZU_ERHALTEN: `um Zugang zu erhalten`,
  SMARTMIRROR: `SmartMirror  +`,
  SMARTMIRROR1: `SmartMirror`,
  VERBINDUNG_ERFOLGREICH: `Verbindung erfolgreich.`,
  SEHE_DIREKT_WO_DU_DICH_VERBES: `Sehe direkt, wo Du Dich verbessern kannst.`,
  SCANNE_DEN_CODE_MIT_DER: `Scanne den Code mit der`,
  KAMERA_APP: `Kamera-App`,
  AUF_DEINEM_IOS_GER_T: `auf Deinem iOS-Gerät.`,
  STELLE_DEN_SMART_MIRROR_AUF_UN: `Stelle den Smart Mirror auf und richte ihn passend zu Deiner Yoga-Matte
        aus.`,
  STARTE_DEINE_SESSION: `Starte Deine Session.`,
  ERSTELLE_JETZT_DEINEN_YUU_YOGA: `ERSTELLE JETZT DEINEN YUU YOGA ACCOUNT IN DER APP`,
  UM_UNSERE_WEB_APP_ZU_NUTZEN_M: `Um unsere Web-App zu nutzen, musst Du bereits einen Account
                besitzen. Diesen kannst Du in der Yuu Yoga App erstellen.`,
  FFNE_DAZU_EINFACH_DIE_APP_UND: `Öffne dazu einfach die App und klicke auf "Neuen Account
                erstellen". Danach kannst Du hierher zurückkehren und Dich auch
                in der Web-App einloggen.`,
  EINLOGGEN: `Einloggen`,
  HTTPS_APPS_APPLE_COM_APP_APP: `https://apps.apple.com/app/apple-store/id1540962781`,
  ZUM_APP_STORE: `Zum App Store`,
  JOURNEY_ERFOLGREICH_ABGESCHLOS: `Journey erfolgreich abgeschlossen`,
  DEINE_EMAIL_ADRESSE_BEST_TIGEN: `Deine Email Adresse bestätigen.`,
  DU_HAST_VERSUCHT_DEINE_EMAIL_A: `Du hast versucht Deine Email Adresse zu bestätigen, leider
                können wir dies momentan nur in der App durchführen. Bitte öffne
                die Email bzw. den Link nochmals auf Deinem Handy, um die
                Bestätigung durchzuführen. Danke für Deine Hilfe!`,
  SMART_MIRROR1: `Smart Mirror:`,
  VERBINDE_DEIN_PHONE: `Verbinde Dein Phone`,
  ALLE_KURSE: `Alle Kurse`,
  LIVE_TRAININGS: 'Live-Trainings',
  LIVE_NAV: 'Live',
  LIVE_SHOW_ALL: 'Alle Live-Trainings anzeigen',
  LIVE_JOIN: 'Jetzt teilnehmen',
  LIVE_AVAILABLE_SOON: 'Bald verfügbar',
  LIVE_FULL: 'Kurs ausgebucht',
  LIVE_FREE: 'KOSTENLOS',
  LIVE_EMPTY: 'Ein neuer Termin folgt in Kürze',
  LIVE_NO_CREDITS:
    'Keine Eintritte verfügbar. Wähle in der mobilen App ein Eintrittspaket.',
  LIVE_JOIN_ERROR:
    'Das Training konnte nicht geöffnet werden. Prüfe, ob du einen verfügbaren Eintritt hast.',
  LIVE_JOIN_CONFIRM:
    'Die Teilnahme verbraucht 1 Eintritt aus deinem Paket, unabhängig davon, wie lange du im Training bleibst. Möchtest du fortfahren?',
  LIVE_FREE_JOIN_CONFIRM:
    'Dieses Training ist kostenlos und verbraucht keinen Eintritt. Möchtest du teilnehmen?',
  LIVE_REJOIN_CONFIRM:
    'Dieses Training ist bereits bezahlt. Du kannst erneut teilnehmen, ohne einen weiteren Eintritt zu verbrauchen. Möchtest du fortfahren?',
  LIVE_BALANCE: 'Verfügbare Eintritte',
  SPLIT_CHALLENGE: 'Spagat-Challenge',
  SPLIT_CHALLENGE_TODAY: 'Heutiges Training',
  SPLIT_CHALLENGE_EMPTY: 'Das heutige Training erscheint in Kürze',
  FAVORITEN: `Favoriten`,
  VISUELLES_FEEDBACK_SO_FUNKTI1: `Visuelles Feedback – so funktioniert's`,
  ALLE_VORTEILE_VON_YUU_YOGA_IN: `Alle Vorteile von Yuu Yoga in 60 Sekunden.`,
  NOCH_FRAGEN_WIR_HELFEN_DIR_GE: `Noch Fragen? Wir helfen dir gerne weiter.`,
  YUU_YOGA_IST_YOGA_ZU_HAUSE_WEI: `Yuu Yoga ist Yoga zu Hause weitergedacht. Im Mittelpunkt
                    steht deine persönliche Yoga-Journey. Du möchtest zu Hause
                    Yoga machen, aber bist dir unsicher, ob Du die Übungen
                    wirklich korrekt ausführst und machst deswegen nur langsam
                    Fortschritte? Yuu Yoga hilft dir mit visuellem Feedback
                    diese Probleme zu vermeiden.`,
  MIT_DEM_SMARTMIRROR_KANNST_DU: `Mit dem SmartMirror kannst Du direkt in der Session deine
                    Pose, mit der der Lehrerin vergleichen und diese selbständig
                    verbessern. Alles was Du dazu benötigst ist Dein Laptop und
                    ein Smartphone.`,
  DURCH_DIE_POSE_COMPARISON_GEBE: `Durch die Pose Comparison geben wir Dir nach jeder Session
                    Feedback zu einzelnen Posen und einen direkten Vergleich zu
                    Deiner Yogalehrerin. Das hilft Dir Dich kontinuierlich zu
                    verbessern.`,
  UNSERE_YOGALEHRERINNEN_HELFEN: `Unsere YogalehrerInnen helfen dir angepasst an Dein
                    persönliches Level verschiedene Yoga-Styles auszuprobieren.
                    Von sanftem Hatha-Yoga für mehr Flexibilität, über
                    sportlich-fordernde Vinyasa-Flows bis hin zu ruhigen
                    Yin-Yoga-Einheiten ist alles dabei. Möchtest Du Deine
                    Routine selber planen oder einfach entspannt eine einzelne
                    Session absolvieren, kannst aus einer großen Anzahl Sessions
                    in verschiedenen Längen die für dich passende wählen.`,
  SOLLTE_DIE_RICHTIGE_SESSION_F: `Sollte die richtige Session für dich nicht dabei sein,
                    schreib uns gerne unter hello@yuuxyoga.de und wir schauen,
                    ob wir dazu noch mehr ins Programm aufnehmen können.`,
  ALLE_YUU_YOGA_KURSE_WERDEN_VON: `Alle Yuu Yoga Kurse werden von natürlich zertifizierten
                    Yogalehrerinnen angeleitet. Am Besten stellen sie sich Dir
                    selber vor:`,
  LISA: `Lisa`,
  SCH_N_DICH_KENNENZULERNEN_IC: `Schön Dich kennenzulernen – Ich bin Lisa, zertifizierte
                    Intensiv-Yogalehrerin und freue mich sehr mit Dir zusammen
                    Yoga zu machen. In meinen Yoga-Sessions biete ich Dir die
                    Chance, Yoga als persönliche Energiequelle zu nutzen, bei
                    der Du neue Kraft und Inspiration schöpfen kannst. Dabei
                    kannst Du über Dich selbst hinauswachsen und Dein
                    Selbstbewusstsein stärken. Du bist neugierig geworden? Dann
                    schnapp Dir Deine Yogamatte und starte mit mir Deine
                    Session.`,
  RICARDA: `Ricarda`,
  HEY_YOGI_ICH_BIN_RICARDA_YOG: `Hey Yogi, ich bin Ricarda, Yogalehrerin aus Berlin mit dem
                    Schwerpunkt auf Hatha-Vinyasa und Yin Yoga. Nachdem ich
                    selbst schon viele Jahre begeistert Yoga praktiziert habe,
                    habe ich schließlich meine Ausbildung im schönen Mexiko
                    gemacht, im Anschluss gleich angefangen viel zu unterrichten
                    und bin immer neugierig auf mehr Yoga Know-How geblieben.
                    Mir ist sehr wichtig, dass wir uns selbst nicht zu ernst
                    nehmen und gerne auch mal mit Humor durch die Asanas fließen
                    – uns jedoch während & im Anschluss noch wohler, stärker
                    und ausgeglichener fühlen.`,
  JULI: `Juli`,
  NAMAST_WIE_SCH_N_DASS_DU_DA: `Namasté, wie schön dass Du da bist! Ich bin Juli,
                    Diplom-Psychologin und zertifizierte Yoga- und
                    Meditationslehrerin. Wenn Du Dir mehr Entspannung,
                    Gelassenheit und Selbstliebe für Dein Leben wünschst und
                    nebenbei auch noch beweglicher werden möchtest, bist Du hier
                    genau richtig. Du findest bei mir Videos zwischen 5 und 30
                    Minuten, vom sanften Hatha-Yoga für mehr Flexibilität, über
                    sportlich-fordernde Vinyasa-Flows bis hin zu ruhigen
                    Yin-Yoga-Einheiten ist alles dabei. Mach’s Dir auf Deiner
                    Yogamatte bequem und lass uns gleich loslegen, ich freu’
                    mich auf Dich!`,
  CORA: `Cora`,
  ICH_BIN_ZERTIFIZIERTE_YOGALEHR: `Ich bin zertifizierte Yogalehrerin und Beraterin für
                    holistische Gesundheit & ich lebe mit meinen zwei Hunden
                    & meinem Freund in Sellin an der Ostsee. Schön dass Du
                    da bist und vielleicht ein bisschen Yoga mit mir machst...
                    Yoga ist für mich die Körper/Geist Verbindung - Der äußere
                    Weg der ins Innere führt, denn die Reise zu Dir selbst ist
                    die Spannendste, die Du je machen wirst. Hier darfst Du ganz
                    Du selbst sein. Du darfst ankommen, zur Ruhe kommen, Deine
                    Gefühle rauslassen, über Dich selbst lachen, Dich
                    herausfordern, Dich annehmen. Ich freue mich, wenn ich Dich
                    auf Deinem Weg ein Stück begleiten darf…`,
  EGAL_OB_NEULING_ODER_ERFAHRENE: `Egal ob Neuling oder erfahrene Yogini, Yuu Yoga bietet Dir
                    auf Deine Bedürfnisse angepasste Kurse. Unsere Yoga
                    LehrerInnen begleiten Dich auf Deiner Journey und helfen Dir
                    über Dein aktuelles Level hinauszuwachsen.`,
  VERBINDEST_DU_LAPTOP_UND_SMART: `Verbindest du Laptop und Smartphone zu Beginn der Session,
                    hilft dir Yuu Yoga mit visuellem Feedback noch mehr aus
                    Deiner Session zu machen. Du nutzst nämlich die Kamera
                    Deines Smartphones, um Dich auf dem großen Bildschirm
                    Seite-an-Seite mit der Yogalehrerin zu sehen.`,
  DIE_VERBINDUNG_DER_BEIDEN_GER: `Die Verbindung der beiden Geräte efolgt über das Scannen von
                    QR-Codes mit Deinem Smartphone. Die Möglichkeit und Anleiung
                    dazu bekommst du im Produkt, sobald du dir ein Video
                    herausgesucht hast.`,
  ALTERNATIV_ZUM_LAPTOP_KANNST_D: `Alternativ zum Laptop kannst du auch ein Tablet für den
                    größeren Screen benutzen, sofern der Bildschirm groß genug
                    ist.`,
  DEINE_DATEN_GEH_REN_DIR_DESWE: `Deine Daten gehören dir. Deswegen kann weder unser Team,
                    noch eine andere Person dir während Deiner Yoga Session
                    zuschauen.`,
  ENTSCHEIDEST_DU_DICH_DEN_SMART: `Entscheidest du dich den Smart Mirror zu aktivieren, wird
                    Dein Live-Bild von Deinem Smartphone auf Dein Laptop oder
                    Tablet übertragen, jedoch nicht gespeichert.`,
  M_CHTEST_DU_ZUS_TZLICH_DIE_POS: `Möchtest du zusätzlich die Pose Comparison nutzen, werden
                    während der Session Bilder Deiner einzelnen Posen
                    aufgenommen und dir am Ende angezeigt. Die Bilder aller
                    Deiner vergangenen Sessions findest du`,
  WARUM_YUU_YOGA_WELCHE_VORTEIL: `Warum Yuu Yoga? Welche Vorteile bieten „Pose Comparison“ und „Smart Mirror“?`,
  WELCHE_VERSCHIEDENEN_KURSE_UND: `Welche verschiedenen Kurse und Sessions bietet Yuu Yoga an?`,
  VON_WEM_WERDEN_DIE_SESSIONS_AN: `Von wem werden die Sessions angeleitet?`,
  MUSS_ICH_BEREITS_YOGA_ERFAHRUN: `Muss ich bereits Yoga-Erfahrung für Yuu Yoga mitbringen?`,
  MIT_WELCHEN_GER_TEN_KANN_ICH_Y: `Mit welchen Geräten kann ich Yuu Yoga nutzen?`,
  WANN_WERDEN_BILDER_UND_VIDEOS: `Wann werden Bilder und Videos von mir gemacht und wer kann diese sehen?`,
  ZUR_POSE_COMPARISON: `zur Pose Comparison`,
  COURSECAROUSEL_ITEM: `coursecarousel-item-`,
  SO_FUNKTIONIERT_S: `So funktioniert’s`,
  DEINE_POSE_COMPARISONS: `Deine Pose Comparisons`,
  KURSE_F_R_DICH: `Kurse für Dich`,
  DEINE_FAVORITEN: `Deine Favoriten`,
  DEINE_TRAINERINNEN: `Deine Trainerinnen`,
  HOL_DIR_DIE_APP: `Hol’ dir die App.`,
  UM_DIR_YOGA_IN_BESTER_QUALIT_T: `Um Dir Yoga in bester Qualität bieten zu können, kannst Du Yuu Yoga
            auf Deinem Smartphone momentan nur mit unserer App verwenden. Lade
            Dir diese einfach im App Store herunter.`,
  MEINE_SESSIONS_BISHER: `Meine Sessions bisher`,
  MEIN_FORTSCHRITT: `Mein Fortschritt`,
  DEINE_POSE_COMPARISONS_PER_S: `Deine Pose Comparisons - per Session`,
  BEREITS_GESTARTETE_KURSE: `Bereits gestartete Kurse`,
  DEINE_JOURNEY: `Deine Journey`,
  ABGESCHLOSSENE_SESSIONS: `Abgeschlossene Sessions`,
  DIESE_WOCHE: `Diese Woche`,
  DIESEN_MONAT: `Diesen Monat`,
  DIESES_JAHR: `Dieses Jahr`,
  DEINE_EMAIL_ADRESSE: `Deine Email-Adresse`,
  ANGEMELDET_SEIT: `Angemeldet seit`,
  DEIN_AKTUELLES_ABONNEMENT: `Dein aktuelles Abonnement:`,
  GEKAUFT_AM: `(gekauft am`,
  G_LTIG_BIS: 'gültig bis',
  MAILTO_INFO_YUUXYOGA_DE_SUBJEC: `mailto:info@yuuxyoga.de?subject=Ich möchte meinen Account löschen`,
  NUR_NOCH_WENIGE_SCHRITTE_ENTFE: `Nur noch wenige Schritte entfernt...`,
  BITTE_W_HLE_NUN_AUF_DIESEM_GER: `Bitte wähle nun auf diesem Gerät eine Session aus, die du
                starten möchtest.`,
  ZUR_AUSWAHL: `Zur Auswahl`,
  BITTE_MELDE_DICH_NUN_AUF_DIESE: `Bitte melde dich nun auf diesem Gerät an und wähle eine Session
                aus, die du starten möchtest.`,
  ZUM_LOGIN: `Zum Login`,
  AN_VORDEFINIERTEN_ZEITPUNKTEN: `An vordefinierten Zeitpunkten halten wir ein Bild Deiner
              Ausführung fest, so dass du sie jetzt mit der der Lehrerin
              vergleichen und deinen Fortschritt auf Social Media teilen kannst.`,
  DEIN_YUU_YOGA_ABO_IST_ABGELAUF: `Dein Yuu Yoga-Abo ist abgelaufen.`,
  MOMENTAN_HAST_DU_KEINEN_ZUGRIF: `Momentan hast Du keinen Zugriff mehr auf die Inhalte von Yuu
                Yoga. Um Dein Abo wieder zu aktivieren nutze bitte die Yuu Yoga
                App.`,
  HIER_KANNST_DU_EINFACH_UND_UMK: `Hier kannst Du einfach und umkompliziert Dein Abo wieder
                aktivieren. Öffne einfach die App, wähle ein neues Paket aus und
                aktiviere dieses via inApp-Purchase.`,
  UNG_LTIGE_E_MAIL_ADRESSE: `Ungültige E-Mail Adresse.`,
  JETZT_VORMERKEN: `Jetzt vormerken`,
  F_R_DIE_ANDROID_VERSION: `für die Android Version.`,
  ICH_M_CHTE_INFORMIERT_WERDEN: `Ich möchte informiert werden, sobald die Yuu Yoga App auch als Android
          App verfügbar ist.`,
  ABSCHICKEN: `Abschicken`,
  AKTUELL_NUR: `Aktuell nur`,
  F_R_IOS_VERF_GBAR: `für iOS verfügbar.`,
  MOMENTAN_BIETEN_WIR_YUU_YOGA_N: `Momentan bieten wir Yuu Yoga nur als App für iOS an. Eine Version für
      Android-Smartphones ist in Planung.`,
  LASS_DICH_GERNE_VORMERKEN_UND: `Lass Dich gerne vormerken und wir geben dir Bescheid sobald, diese
      verfügbar ist.`,
  WIR_MELDEN_UNS: `Wir melden uns!`,
  DANKE_F_R_DEIN_INTERESSE: `Danke für Dein Interesse.`,
  LEIDER_KONNTE_DIE_SEITE_NICHT: `Leider konnte die Seite nicht gefunden werden :(`,
  ANWENDUNGSBEREICH: `Anwendungsbereich`,
  DIESE_COOKIE_POLICY_GILT_ERG_N: `Diese Cookie Policy gilt ergänzend zur allgemeinen Datenschutzerklärung
        für unsere Website und beschreibt Art, Umfang, Zwecke und
        Rechtsgrundlagen der Datenverarbeitung bei Cookies. Im Übrigen gilt
        hinsichtlich aller weiteren Informationen die allgemeine
        Datenschutzerklärung.`,
  WAS_SIND_COOKIES: `Was sind Cookies?`,
  UM_IHNEN_EINEN_UMFANGREICHEN_F: `Um Ihnen einen umfangreichen Funktionsumfang zu bieten, die Nutzung
        komfortabler zu gestalten und um unsere Angebote optimieren zu können,
        verwenden wir sogenannte „Cookies“. Cookies sind kleine Dateien, die mit
        Hilfe Ihres Internetbrowsers auf Ihrem Endgerät gespeichert werden.`,
  KATEGORIEN_VON_COOKIES: `Kategorien von Cookies`,
  WIR_SETZEN_COOKIES_ZU_UNTERSCH: `Wir setzen Cookies zu unterschiedlichen Zwecken und mit
        unterschiedlichen Funktionen ein. Hierbei unterscheiden wir danach, ob
        der Cookie technisch zwingend erforderlich ist (Technische
        Erforderlichkeit), wie lange er gespeichert und verwendet wird
        (Speicherdauer) und ob er durch unsere Webseite selbst oder durch Dritte
        sowie durch welchen Anbieter dieser Cookie gesetzt wurde
        (Cookie-Anbieter).`,
  TECHNISCHE_ERFORDERLICHKEIT: `Technische Erforderlichkeit`,
  TECHNISCH_ERFORDERLICHE_COOKIE: `Technisch erforderliche Cookies: Wir verwenden bestimmte Cookies, weil
        sie zwingend erforderlich sind, damit unsere Website ordnungsgemäß
        arbeiten können. Diese Cookies werden automatisch bei Aufruf unserer
        Website oder einer bestimmten Funktion gesetzt, es sei denn, Sie haben
        das Setzen von Cookies durch entsprechende Einstellungen in Ihrem
        Endgerät bzw. Browser verhindert.`,
  TECHNISCH_NICHT_ERFORDERLICHE: `Technisch nicht erforderliche Cookies: Demgegenüber werden nicht
        zwingend erforderliche Cookies gesetzt, um beispielsweise Komfort und
        Leistung der Website zu verbessen oder bestimmte von Ihnen vorgenommene
        Einstellungen zu speichern. Wir setzen technisch nicht erforderliche
        Cookies außerdem ein, um Informationen zur Nutzungshäufigkeit bestimmter
        Bereiche unserer Website zu ermitteln, damit wir diese zukünftig
        gezielter auf Ihre Bedürfnisse abstimmen können.`,
  SPEICHERDAUER: `Speicherdauer`,
  SESSION: `Session`,
  HIER: 'hier',
  SESSION_COOKIES_DIE_MEISTEN_C: `Session-Cookies: Die meisten Cookies werden lediglich für die Dauer
        Ihres aktuellen Dienste-Aufrufs oder Ihrer Sitzung (Session) benötigt
        und wieder gelöscht bzw. verlieren ihre Gültigkeit, sobald Sie unsere
        Website verlassen oder Ihre aktuelle Sitzung abläuft (sogenannte
        „Session Cookies“). Session Cookies werden beispielsweise verwendet, um
        während Ihrer Sitzung bestimmte Informationen wie etwa Ihre Anmeldung
        für unsere Website beizubehalten.`,
  PERMANENT_COOKIES_NUR_VEREINZ: `Permanent Cookies: Nur vereinzelt werden Cookies über einen längeren
        Zeitraum gespeichert, etwa um Sie beim erneuten Aufruf unserer Website
        zu einem späteren Zeitpunkt wiedererkennen und gespeicherte
        Einstellungen aufrufen zu können. Hierdurch können Sie beispielsweise
        schneller oder bequemer auf unsere Website zugreifen oder müssen
        bestimmte Einstellungen wie Ihre gewählte Sprache nicht erneut
        vornehmen. Permanent Cookies werden nach Ablauf eines vordefinierten
        Zeitraums automatisch gelöscht.`,
  COOKIE_ANBIETER: `Cookie-Anbieter`,
  DRITTANBIETER_COOKIES_SOGENAN: `Drittanbieter-Cookies: Sogenannte „Drittanbieter-Cookies“ werden durch
        andere Stellen oder Webseiten, beispielsweise durch Anbieter von Tools
        zur Webanalyse gesetzt und verwendet. Nähere Informationen zu Tools zur
        Webanalyse erhalten Sie im weiteren Verlauf dieser Cookie Policy.
        Drittanbieter können Cookies außerdem verwenden, um Werbung anzuzeigen
        oder um Inhalte sozialer Netzwerke wie z.B. Social Plugins zu
        integrieren.`,
  EINSATZ_VON_TOOLS_ZUR_WEBANALY: `Einsatz von Tools zur Webanalyse`,
  WIR_VERWENDEN_IM_BEREICH_DER_N: `Wir verwenden im Bereich der Nutzungsanalyse den Webanalysedienst Google
        Analytics, angeboten von Google Ireland Ltd., Gordon House, Barrow
        Street, Dublin 4, Irland. Google Analytics verwendet
        Drittanbieter-Cookies, um die Häufigkeit der Nutzung bestimmter Bereiche
        unserer Website und Präferenzen zu identifizieren. Die durch den Cookie
        erzeugten Informationen über Ihre Nutzung (einschließlich Ihrer
        verkürzten IP-Adresse) werden an einen Server von Google in den USA
        übertragen und dort gespeichert. Google wird diese Informationen in
        unserem Auftrag benutzen, um Ihre Nutzung unserer Website auszuwerten,
        um Reports für uns zusammenzustellen und um weitere mit der Webanalyse
        verbundene Dienstleistungen zu erbringen. Informationen zum Datenschutz
        und zur Sicherheit bei Google Analytics finden Sie unter
        https://support.google.com/analytics/answer/6004245?hl=en.`,
  WIR_SETZEN_F_R_UNSERE_MARKETIN: `Wir setzen für unsere Marketingmaßnahmen und im Bereich der
        Nutzungsanalyse den Dienst Facebook Pixel ein (Anbieter: Facebook
        Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2,
        Irland). Hiermit kann einer bestimmten definierten Zielgruppe auf ihre
        Interessen zugeschnittene Werbung ausgespielt werden. Die Werbung bei
        Facebook und dessen Partnern wird dann nur solchen Nutzern angezeigt,
        die angesichts ihres Nutzungsverhaltens Interesse an den entsprechenden
        Angeboten haben könnten (sog. Custom Audiences). Wenn Sie sich im
        Zusammenhang mit der Nutzung unserer Website bzw. App bei Facebook
        einloggen, wird eine Verbindung zum Facebook-Server hergestellt und
        diese Information mit Ihrem Facebook-Account verbunden, damit Sie ggf.
        einer Zielgruppe zugeordnet werden können. Facebook sammelt aber ggf.
        auch Daten, wenn Sie nicht parallel in Ihrem Facebook-Account eingeloggt
        sind. Über den Facebook Pixel können wir zudem statistisch
        nachvollziehen, welche Werbung zu einem Besuch unserer Website bzw. App
        geführt hat. So können wir die Effizienz unserer Anzeigen für
        statistische Zwecke und Marktforschungszwecke auswerten und auf dieser
        Grundlage zukünftige Werbemaßnahmen optimieren. Weitere Informationen
        zum Datenschutz in Bezug auf den Facebook Pixel finden Sie unter
        https://de-de.facebook.com/privacy/explanation.`,
  WIR_VERWENDEN_ZUR_ANALYSE_DER: `Wir verwenden zur Analyse der Stabilität der Anwendungen und zur
        Ermittlung von Fehlfunktionen der Programmierung den Dienst Sentry
        (Anbieter: Functional Software, 132 Hawthorne Street, San Francisco, CA
        94107, USA). Sentry verwendet Drittanbieter-Cookies, um in unserem
        Auftrag Informationen zur Analyse wie Angaben zum verwendeten Gerät oder
        zum Fehlerzeitpunkt zu ermitteln und uns zur Verfügung zu stellen.
        Weitere Informationen zum Datenschutz und zur Sicherheit bei Sentry
        finden Sie unter https://sentry.io/privacy/.`,
  WIR_VERWENDEN_IM_BEREICH_DER_N1: `Wir verwenden im Bereich der Nutzungsanalyse den Webanalysedienst
        FullStory (Anbieter: FullStory, Inc., 1745 Peachtree St NE, Suite G,
        Atlanta GA 30309, USA). FullStory verwendet Drittanbieter-Cookies, um
        das Nutzerverhalten auf der Website zu analysieren (ausgewählte Links,
        Spezifikationen des abrufenden Endgeräts, Klicks, Mausbewegungen).
        FullStory wird die gesammelten Informationen in unserem Auftrag und auf
        Basis eines Vertrages zur Auftragsverarbeitung verwenden, um Ihre
        Nutzung unserer Website auszuwerten, um Reports über die
        Nutzungs-Aktivitäten für uns zusammenzustellen und um weitere damit
        verbundene Dienstleistungen zu erbringen. Weitere Informationen zum
        Datenschutz in Bezug auf FullStory finden Sie unter
        https://www.fullstory.com/legal/privacy-policy.`,
  WIR_NUTZEN_TRACKING_TECHNOLOGI: `Wir nutzen Tracking-Technologien des Anbieters Singular (Singular Labs
        Inc., 181 South Park Street, Apt 2, San Francisco, CA 94107, USA). Um
        unsere Dienste konstant zu verbessern, erheben wir mit Singular Daten
        über die Nutzung unserer Dienste und darüber, durch welche
        Kampagnen/Drittseiten Sie auf unsere Dienste geleitet wurden. Es werden
        dazu insbesondere Informationen genutzt, die Ihr Endgerät an uns
        übermittelt wie etwa die IP-Adresse oder Werbe-Identifier, die über das
        Betriebssystem des Endgeräts vergeben werden. Weitere Informationen zum
        Datenschutz in Bezug auf Singular finden Sie unter
        https://www.singular.net/privacy-policy.`,
  RECHTSGRUNDLAGE_F_R_DEN_EINSAT: `Rechtsgrundlage für den Einsatz der Cookies`,
  SOWEIT_SIE_DIE_WEBSITE_NUTZEN: `Soweit Sie die Website nutzen, setzen wir technisch nicht erforderliche
        Cookies nur ein, wenn Sie Ihre Einwilligung per Opt-in erklärt haben.
        Die gesetzliche Grundlage ist dann Artikel 6 Absatz 1 Buchstabe a)
        DSGVO. Sie können Ihre Einwilligung jederzeit mit Wirkung für die
        Zukunft widerrufen, indem Sie das Opt-in durch die entsprechenden
        Einstellungsmöglichkeiten der Website bzw. Ihres Browsers deaktivieren.
        Die gesetzliche Grundlage für den Einsatz technisch erforderlicher
        Cookies ist Artikel 6 Absatz 1 Buchstabe f) DSGVO; unser berechtigtes
        Interesse besteht darin, dass unsere Website ordnungsgemäß arbeiten
        können muss.`,
  L_SCHUNG_UND_WIDERSPRUCH_GEGEN: `Löschung und Widerspruch gegen die Verwendung von Cookies`,
  DIE_AKZEPTANZ_VON_COOKIES_IST: `Die Akzeptanz von Cookies ist nicht verpflichtend; falls Sie nicht
        möchten, dass Cookies auf Ihrem Endgerät gespeichert werden, können Sie
        die entsprechende Option in den Systemeinstellungen Ihres Endgeräts bzw.
        Ihres Browsers deaktivieren. Gespeicherte Cookies können Sie in den
        Systemeinstellungen Ihres Endgeräts bzw. Ihres Browsers jederzeit
        löschen. Wenn Sie keine Cookies akzeptieren, kann dieses allerdings zu
        Funktionseinschränkungen unserer Angebote führen.`,
  LISTE_DER_COOKIES: `Liste der Cookies`,
  IM_EINZELNEN_K_NNEN_BEIM_AUFRU: `Im Einzelnen können beim Aufrufen unserer Webseite folgende Cookies
        gespeichert werden:`,
  EINSTELLUNGEN_ZU_COOKIES_ANZEI: `Einstellungen zu Cookies anzeigen`,
  LINKS_DEFAULT: `links.default`,
  ANBIETER: `Anbieter`,
  INITIUM_GMBH: `Initium GmbH`,
  STRALAUER_ALLEE: `Stralauer Allee 12`,
  BERLIN: `10245 Berlin`,
  DEUTSCHLAND: `Deutschland`,
  KONTAKT: `Kontakt`,
  TELEFONNUMMER: `Telefonnummer: +49 (0) 711 911 37000`,
  E_MAIL: `E-Mail:`,
  VERTRETEN_DURCH: `Vertreten durch`,
  MATTIAS_ULBRICH_STEFAN_ZERWEC: `Mattias Ulbrich, Stefan Zerweck`,
  REGISTRIEREINTRAG: `Registriereintrag`,
  REGISTERGERICHT_AMTSGERICHT_C: `Registergericht: Amtsgericht Charlottenburg (Berlin)`,
  HRB_NR_B: `HRB-Nr.: 216902 B`,
  UST_IDENT_NR_DE: `USt-Ident.-Nr.: DE332621103`,
  VERBRAUCHERINFORMATION_GEM_SS: `Verbraucherinformation gemäß Verbraucherstreitbeilegungsgesetz`,
  DIE_INITIUM_GMBH_IST_NICHT_BER: `Die Initium GmbH ist nicht bereit und verpflichtet, an
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.`,
  WIR_DIE_INITIUM_GMBH_NACHFOL: `Wir, die Initium GmbH (nachfolgend „wir“ oder „Initium“), freuen uns
        über Ihr Interesse an unserem Online-Angebot Yuu Yoga, das wir Ihnen per
        App und ergänzend per Website anbieten (nachfolgend das
        „Online-Angebot“). Wir nehmen den Schutz Ihrer personenbezogenen Daten
        sehr ernst. Die Verarbeitung Ihrer personenbezogenen Daten erfolgt
        ausschließlich im Rahmen der gesetzlichen Bestimmungen des
        Datenschutzrechts, insbesondere der Datenschutzgrundverordnung
        (nachfolgend „DSGVO“). Mit dieser Datenschutzerklärung informieren wir
        Sie über die Verarbeitung Ihrer personenbezogenen Daten und über Ihre
        Rechte als betroffene Person im Rahmen des Online-Angebots.`,
  SOFERN_WIR_VON_EXTERNEN_SOCIAL: `Sofern wir von externen Social-Media-Profilen auf diese
        Datenschutzerklärung verweisen, gelten die folgenden Erläute-rungen nur
        insoweit, als die Verarbeitung in unserem Verantwortungsbereich erfolgt
        und soweit keine spezielleren und deshalb vorrangigen Hinweise zum
        Datenschutz im Rahmen solcher Social-Media-Profile zur Verfügung
        gestellt werden.`,
  VERANTWORTLICHER_UND_DATENS: `1. Verantwortlicher und Datenschutzbeauftragter`,
  VERANTWORTLICH_F_R_DIE_DATENVE: `Verantwortlich für die Datenverarbeitung im Sinne der Datenschutzgesetze
        ist die:`,
  SOLLTEN_SIE_FRAGEN_ODER_ANREGU: `Sollten Sie Fragen oder Anregungen zum Datenschutz haben, können Sie
        sich gerne an uns wenden. Unseren Datenschutzbeauftragten erreichen Sie
        wie folgt:`,
  BEAUFTRAGTER_F_R_DATENSCHUTZ: `Beauftragter für Datenschutz`,
  DATENSCHUTZBEAUFTRAGTER_INITIU: `datenschutzbeauftragter@initium.gmbh`,
  GEGENSTAND_DES_DATENSCHUTZE: `2. Gegenstand des Datenschutzes`,
  GEGENSTAND_DES_DATENSCHUTZES_I: `Gegenstand des Datenschutzes ist der Schutz personenbezogener Daten.
        Diese sind alle Informationen, die sich auf eine identifizierte oder
        identifizierbare natürliche Person (sog. betroffene Person) beziehen.
        Hierunter fallen Angaben wie z.B. Name, Post-Adresse, E-Mail-Adresse
        oder Telefonnummer, aber auch sonstige Informationen, die im Rahmen der
        Nutzung des Online-Angebots entstehen, insbesondere Angaben über Beginn,
        Ende und Umfang der Nutzung sowie die Übermittlung Ihrer IP-Adresse.`,
  ZWECKE_UND_RECHTSGRUNDLAGEN: `3. Zwecke und Rechtsgrundlagen der Datenverarbeitung`,
  NACHFOLGEND_ERHALTEN_SIE_EINEN: `Nachfolgend erhalten Sie einen Überblick über Zwecke und
        Rechtsgrundlagen der Datenverarbeitung im Rahmen des Online-Angebots.
        Wir verarbeiten personenbezogene Daten jedenfalls entsprechend der
        rechtlichen Vorgaben, auch wenn im Einzelfall eine andere
        Rechtsgrundlage einschlägig sein sollte als im Folgenden angegeben.`,
  DIE_BEREITSTELLUNG_PERSONENBEZ: `Die Bereitstellung personenbezogener Daten durch Sie kann dabei
        gesetzlich oder vertraglich vorgeschrieben bzw. für einen
        Vertragsabschluss erforderlich sein. Wir weisen Sie gesondert darauf
        hin, wenn Sie verpflichtet sein sollten, personenbezogene Daten
        bereitzustellen und welche möglichen Folgen die Nichtbereitstellung dann
        hätte (z.B. ein Verlust von Ansprüchen oder unser Hinweis, ohne
        Bereitstellung bestimmter Angaben die angeforderte Leistung nicht zu
        erbringen). Die Nutzung des Online-Angebots ist grundsätzlich ohne
        Registrierung möglich. Die Nutzung einzelner Dienste und Funktionen kann
        eine vorherige Registrierung erfordern. Auch wenn Sie unser
        Online-Angebot ohne Registrierung nutzen, können dennoch
        personenbezogene Daten verarbeitet werden.`,
  ERF_LLUNG_VERTRAGLICHER_UN: `3.1 Erfüllung vertraglicher und vorvertraglicher Pflichten`,
  WIR_VERARBEITEN_IHRE_PERSONENB: `Wir verarbeiten Ihre personenbezogenen Daten, wenn dies für die
        Durchführung eines Vertrages, dessen Partei Sie sind, bzw. für die
        Durchführung vorvertraglicher Maßnahmen, die auf Ihre Anfrage hin
        erfolgen, erforderlich ist. Die Datenverarbeitung erfolgt auf Basis des
        Artikels 6 Absatz 1 Buchstabe b) DSGVO. Die Zwecke der Verarbeitung
        umfassen die Ermöglichung der Nutzung unserer spezifischen Produkte und
        Dienstleistungen im Rahmen des Online-Angebots. Bitte beachten Sie
        insofern auch die Beschreibungen dieser Produkte und Dienstleistungen im
        Rahmen des Online-Angebots. Dies sind im konkreten Fall insbesondere die
        folgenden Funktionen:`,
  REGISTRIERUNG_F_R_EIN_KONTO: `- Registrierung für ein Konto`,
  MIT_DER_REGISTRIERUNG_F_R_EIN: `Mit der Registrierung für ein Yuu Yoga-Konto mit Ihrer E-Mail-Adresse
        wählen Sie einen selbst vergebenen Benutzerna-men und ein Passwort und
        können über Ihre Kontoeinstellungen nach Wunsch weitere Angaben in Ihrem
        Konto hinzufü-gen. Über Ihr Konto können Sie dann die von Ihnen
        genutzten Funktionen und Inhalte verwalten (Überblick über absolvierte
        Trainings, etc.).`,
  WIR_VERWENDEN_ZUR_REGISTRIERUN: `Wir verwenden zur Registrierung und Anmeldung ein sogenanntes
        „Single-Sign-On-Verfahren“ unter Einbindung der Dienste dritter
        Anbieter. Mithilfe des Single-Sign-On-Verfahrens können Sie sich als
        eingeloggter Nutzer von Facebook (Verantwortlicher: Facebook Ireland
        Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland),
        Google (Verantwortlicher: Google Ireland Ltd., Gordon House, Barrow
        Street, Dublin 4, Irland) oder Apple (Verantwortlicher: Apple Inc.,
        Infinite Loop, Cupertino, CA 95014, USA) für ein Yuu Yoga-Konto
        registrieren und anmelden. Dadurch müssen Sie sich für Yuu Yoga kein
        neues Passwort merken. Alternativ können Sie sich über Ihre
        E-Mail-Adresse registrieren und anmel-den. Dafür benötigen Sie Ihre
        E-Mail-Adresse und ein selbstgewähltes Passwort.`,
  SOLLTEN_SIE_SICH_F_R_DAS_SINGL: `Sollten Sie sich für das Single-Sign-On-Verfahren entscheiden, werden
        Sie auf die Login-/Anmelde-Maske Ihres Accounts bei dem jeweiligen
        Anbieter weitergeleitet, über den das Single-Sign-On-Verfahren
        abgewickelt wird. Hier melden Sie sich mit Ihrem dortigen Benutzernamen
        und Passwort an. Wir erhalten von dem Anbieter die Nachricht, dass Sie
        sich erfolgreich angemeldet haben und die Registrierung bzw. Anmeldung
        wird abgeschlossen. Wir kommen bei diesem Prozess weder mit Ihrem
        Passwort noch mit Ihrem Benutzernamen beim Anbieter, über den das
        Single-Sign-On-Verfahren abgewickelt wird, in Berührung. Bei
        erfolgreicher Registrierung bzw. Anmeldung müssen Sie dem Anbieter
        bestätigen, dass wir auf Ihre Basis-Profildaten (siehe unten für den
        jeweiligen Anbieter) zugreifen dürfen. Dadurch müssen Sie bei Yuu Yoga
        Ihre Basis-Profildaten nicht nochmals pflegen und aktuell halten (wenn
        sich z.B. Ihre Adresse ändert). Sollten Sie sich entscheiden, die
        Verknüpfung ihres Yuu Yoga-Kontos mit dem Account bei dem Anbieter, über
        den das Single-Sign-On-Verfahren abgewickelt wird, aufzuheben, stehen
        Ihnen die entsprechenden Einstellungen bei diesem Anbieter zur
        Verfügung.`,
  WENN_SIE_EIN_YUU_YOGA_KONTO_B: `Wenn Sie ein Yuu Yoga-Konto über Facebook erstellen oder sich über
        Facebook in ein Yuu Yoga-Konto einloggen, übermittelt Facebook bestimmte
        Angaben Ihres Facebook-Accounts an uns: Name, Foto-URL, User-ID, E-Mail.
        Weitere Informationen zu Facebook und den Privatsphäre-Einstellungen
        sind den Datenschutzhinweisen von Facebook unter`,
  HTTPS_WWW_FACEBOOK_COM_POLIC: `https://www.facebook.com/policy.php`,
  ZU_ENTNEHMEN_WENN_SIE_EIN_YUU: `zu entnehmen. Wenn Sie ein Yuu Yoga-Konto über Google erstellen oder
        sich über Google in ein Yuu Yoga-Konto einloggen, übermittelt Google
        bestimmte Angaben Ihres Google-Accounts an uns: Name, Foto-URL, User-ID,
        E-Mail. Weitere Informationen zu Google und den
        Privatsphäre-Einstellungen sind den Datenschutzhinweisen von Google
        unter`,
  HTTPS_POLICIES_GOOGLE_COM_PR: `https://policies.google.com/privacy`,
  ZU_ENTNEHMEN_WENN_SIE_EIN_YUU1: `zu entnehmen. Wenn Sie ein Yuu Yoga-Konto über Apple erstellen oder sich
        über Apple in ein Yuu Yoga-Konto einloggen, übermittelt Apple bestimmte
        Angaben Ihres Apple-Accounts an uns: Name, Foto-URL, User-ID, E-Mail.
        Weitere Informationen zu Apple und den Privatsphäre-Einstellungen sind
        den Datenschutzhinweisen von Apple unter`,
  HTTPS_WWW_APPLE_COM_LEGAL_PR: `https://www.apple.com/legal/privacy/de-ww/`,
  ZU_ENTNEHMEN: `zu entnehmen.`,
  ZUR_DURCHF_HRUNG_DER_AUTHENTIF: `Zur Durchführung der Authentifizierung verwenden wir die Dienste von
        Amazon Cognito (Anbieter: Amazon Web Services, Inc., P.O. Box 81226,
        Seattle, WA 98108-1226, USA). Weitere Informationen finden Sie unter`,
  HTTPS_DOCS_AWS_AMAZON_COM_DE: `https://docs.aws.amazon.com/de_de/cognito/latest/developerguide/cognito-user-pools-identity-federation.html`,
  HINWEISE_ZUM_DATENSCHUTZ_BEI: `. Hinweise zum Datenschutz bei Amazon Cognito finden Sie unter`,
  HTTPS_AWS_AMAZON_COM_DE_PRIV: `https://aws.amazon.com/de/privacy/`,
  DIE_ERHOBENEN_DATEN_VERARBEITE: `Die erhobenen Daten verarbeiten wir auf Basis des Artikels 6 Absatz 1
        Buchstabe b) und f) DSGVO, um Sie mit Ihrem Konto anzule-gen und Sie bei
        jeder Anmeldung zu identifizieren. Wir verfolgen dabei – neben der
        Durchführung des von Ihnen gewünschten Vorgehens bzw. Verfahrens – das
        Interesse, den Prozess von Registrierung und Anmeldung effizient und
        komfortabel auszugestal-ten.`,
  NUTZUNG_DER_FUNKTIONEN: `- Nutzung der Funktionen`,
  YUUYOGA_BIETET_DIE_M_GLICHKEIT: `YuuYoga bietet die Möglichkeit, auf eine Bibliothek von Videoinhalten
        wie Yoga-Workouts und Übungen zuzugreifen und während und nach einem
        durchgeführten Training personalisiertes Feedback über die Art der
        Ausführung zu erhalten. Das personalisierte Feedback zu Ihren
        Fortschritten basiert auf Videoaufzeichnungen des Trainings. Es gibt
        folgende Varianten der Videoaufzeichnung:`,
  SMART_MIRROR_SIE_K_NNEN_SIC: `- Smart Mirror: Sie können sich während des Trainings selbst von der
        gleichen Seitenperspektive wie den Trainer sehen. Es erfolgt
        grundsätzlich keine dauerhafte Aufzeichnung des Videostreams. Eine
        Speicherung einzelner Snapshots kann für die Bereitstellung der
        folgenden Funktionen erfolgen.`,
  POSE_COMPARISON_NACH_DEM_TR: `- Pose Comparison: Nach dem Training können Sie für bestimmte
        Schlüsselposen im Training anhand von Snapshots Ihre Ausführung mit der
        des Trainers vergleichen. Die Snapshots werden dauerhaft aufgezeichnet
        und stehen Ihnen in Ihrem Konto zum Abruf zur Verfügung.`,
  POSE_PROGRESS_SIE_K_NNEN_DI: `- Pose Progress: Sie können die in der Pose Comparison für bestimmte
        Schlüsselposen gemachten Snapshots im Zeitverlauf ansehen, um Ihren
        Fortschritt sichtbar zu machen. Die Snapshots werden dauerhaft
        aufgezeichnet und stehen Ihnen in Ihrem Konto zum Abruf zur Verfügung.`,
  SOWEIT_DAUERHAFTE_VIDEOAUFZEIC: `Soweit dauerhafte Videoaufzeichnungen im Rahmen von Snapshots erfolgen,
        werden diese grundsätzlich so lange ge-speichert, bis Ihr Konto gelöscht
        wird oder Sie einzelne Snapshots im Rahmen der Verwaltung Ihres Kontos
        löschen. Bitte stellen Sie sicher, dass keine weiteren Personen
        aufgezeichnet werden.`,
  BITTE_BEACHTEN_SIE_DIE_WEITERE: `Bitte beachten Sie die weiteren Informationen zur Beschreibung der
        Funktionen in den Nutzungsbedingungen. Soweit für die Nutzung der
        Funktionen ein kostenpflichtiges Abonnement erforderlich sein sollte,
        erhalten Sie weitere Informationen zur damit verbundenen
        Datenverarbeitung und zu den erforderlichen Angaben im Rahmen des
        Bestellprozesses.`,
  DIE_BEI_DER_NUTZUNG_DER_FUNKTI: `Die bei der Nutzung der Funktionen erhobenen Daten und insbesondere die
        Videoaufzeichnungen sowie Daten zur Verifi-kation und Abrechnung von
        Abonnements verarbeiten wir auf Basis des Artikels 6 Absatz 1 Buchstabe
        b) DSGVO, um Ihnen die von Ihnen ausgewählten Funktionen im Rahmen des
        Angebots zur Verfügung zu stellen.`,
  ERF_LLUNG_RECHTLICHER_VERF: `3.2 Erfüllung rechtlicher Verflichtungen`,
  WIR_VERARBEITEN_IHRE_PERSONENB1: `Wir verarbeiten Ihre personenbezogenen Daten, um rechtliche
        Verpflichtungen einzuhalten, denen wir unterliegen. Die
        Datenverarbeitung erfolgt auf Basis des Artikels 6 Absatz 1 Buchstabe c)
        DSGVO. Die Verpflichtungen können sich z.B. aus dem Handels-, Steuer-,
        Geldwäsche-, Finanz- oder Strafrecht ergeben. Die Zwecke der
        Verarbei-tung ergeben sich aus der jeweiligen rechtlichen Verpflichtung;
        die Verarbeitung dient in der Regel dem Zweck, staatlichen Kontroll- und
        Auskunftspflichten nachzu-kommen.`,
  WAHRUNG_BERECHTIGTER_INTER: `3.3 Wahrung berechtigter Interessen`,
  WIR_VERARBEITEN_IHRE_PERSONENB2: `Wir verarbeiten Ihre personenbezogenen Daten darüber hinaus zur Wahrung
        berechtigter Interessen von uns oder Dritten, soweit nicht Ihre
        Interessen, die den Schutz Ihrer personenbezogener Daten erfordern,
        überwiegen. Die Datenverarbeitung erfolgt auf Basis des Artikels 6
        Absatz 1 Buchstabe f) DSGVO. Die Verarbeitung zur Wahrung berechtigter
        Interesse erfolgt zu folgenden Zwecken bzw. zur Wahrung folgender
        Interessen.`,
  WEITERENTWICKLUNG_VON_PRODUK: `- Weiterentwicklung von Produkten, Diensten, Dienstleistungen und
        Betreuungsangeboten sowie sonstige Maßnahmen zur Steuerung von
        Geschäftsvorfällen und -prozessen`,
  VERBESSERUNG_DER_PRODUKTQUAL: `- Verbesserung der Produktqualität, Beseitigung von Fehlern und
        Störungen u.a. mithilfe der Analyse von Nutzungsdaten und
        Kundenrückmeldungen`,
  BEARBEITUNG_VON_AUSSERVERTRA: `- Bearbeitung von außervertraglichen Interessenten- und Kundenanfragen`,
  SICHERSTELLUNG_RECHTSKONFORM: `- Sicherstellung rechtskonformen Handelns, Prävention von und Schutz vor
        Rechtsverstößen (insb. Straftaten), Geltendmachung von und Verteidigung
        gegen rechtliche Ansprüche`,
  GEW_HRLEISTUNG_VON_VERF_GBAR: `- Gewährleistung von Verfügbarkeit, Betrieb und Sicherheit technischer
        Systeme sowie technisches Datenmanagement`,
  WENN_SIE_DAS_ONLINE_ANGEBOT_AU: `Wenn Sie das Online-Angebot aufrufen, werden Daten in Bezug auf Ihr
        Endgerät und Ihre Nutzung des Online-Angebots verarbeitet und in einer
        sog. Log-Datei gespeichert. Dies betrifft insbesondere technische Daten
        wie Datum und Uhrzeit des Zugriffs, Dauer des Besuchs, Art des
        Endgeräts, verwendetes Betriebssystem, genutzte Funktionen, Menge der
        gesen-deten Daten, IP-Adresse und Referrer-URL. Diese Daten verarbeiten
        wir zur Sicherstellung des technischen Betriebs sowie zur Ermittlung und
        Beseitigung von Störungen. Wir verfolgen dabei das Interesse, die
        technische Funktionsfähigkeit dauerhaft sicherzustellen. Wir verwenden
        diese Daten nicht zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen.`,
  EINWILLIGUNG: `3.4 Einwilligung`,
  WIR_VERARBEITEN_IHRE_PERSONENB3: `Wir verarbeiten Ihre personenbezogenen Daten auf Grundlage
        entsprechender Einwilligung. Die Datenverarbeitung erfolgt auf Basis des
        Artikels 6 Absatz 1 Buchstabe a) DSGVO. Sollten Sie eine Einwilligung
        erteilen, ist diese stets zweckgebunden; die Zwecke der Verarbeitung
        ergeben sich jeweils aus dem Inhalt Ihrer Einwilligungserklärung. Eine
        erteilte Einwilligung können Sie jederzeit wider-rufen, ohne dass die
        Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
        Verarbeitung hiervon berührt wird.`,
  SIE_K_NNEN_SICH_BEI_DER_REGIST: `Sie können sich bei der Registrierung oder im Rahmen der Verwaltung
        Ihres Kontos für unseren Newsletter mit Informationen über Yuu Yoga
        anmelden. Wir versenden Newsletter nur nachentsprechender Anmeldung,
        d.h. mit Ihrer Einwilligung auf Basis von Artikel 6 Absatz 1 Buchstabe
        a) DSGVO. Sofern im Rahmen einer Anmeldung zum Newsletter dessen Inhalte
        konkret umschrieben werden, sind diese für die Reichweite der
        Einwilligung maßgeblich. Im Übrigen enthält unser Newsletter
        Informationen zu den Funktionen und Aktionen im Zusammenhang mit Yuu
        Yoga. Sie können Ihre Einwilligung in den Empfang unseres Newsletters
        jederzeit widerrufen, indem Sie sich vom Newsletter abmelden. Einen
        Abmelde-Link zur Ausübung dieses Rechts finden Sie am Ende eines jeden
        Newsletters.`,
  BEI_DER_ERHEBUNG_UND_VERWALTUN: `Bei der Erhebung und Verwaltung Ihrer E-Mail-Adresse nutzen wir den
        Dienst MailChimp (Anbieter: Rocket Science Group, LLC, 675 Ponce De Leon
        Ave NE 5000, Atlanta, GA 30308, USA). Um unseren Newsletter für Sie
        möglichst interessant zu gestalten, wertet MailChimp in unserem Auftrag
        das Nutzungsverhalten aus, ohne Rückschlüsse auf Ihre Person bzw.
        Identität zu ziehen. Auf diese Weise können wir z.B. erfahren, wie viele
        unserer Leser unseren Newsletter geöffnet haben und welche Links
        besonders häufig aufgerufen wurden. Hierbei kommen marktübliche
        Technologien, z.B. Cookies oder in unserem Newsletter eingebaute
        Zählpixel zum Einsatz. Die Datenverarbeitung erfolgt dabei auf Grundlage
        unserer berechtigten Interessen im Sinne des Artikel 6 Absatz 1
        Buchstabe f) DSGVO, nämlich unserem Interesse an der Analyse und
        inhaltlichen Optimierung unseres Newsletters. Weitere Informationen zum
        Datenschutz bei MailChimp finden Sie unter`,
  HTTPS_MAILCHIMP_COM_LEGAL_PR: `https://mailchimp.com/legal/privacy/`,
  ZWECK_NDERUNG: `3.5 Zweckänderung`,
  SOWEIT_WIR_IHRE_PERSONENBEZOGE: `Soweit wir Ihre personenbezogenen Daten jenseits einer entsprechenden
        Einwilligung oder einer zwingenden Rechts-grundlage zu einem anderen
        Zweck verarbeiten als zu demjenigen, zu dem die Daten erhoben wurden,
        berücksichtigen wir gemäß Artikel 6 Absatz 4 DSGVO die Vereinbarkeit des
        ursprünglichen und des nunmehr verfolgten Zwecks, die Art der
        personenbezogenen Daten, die möglichen Folgen der weiteren Verarbeitung
        für Sie und die Garantien zum Schutz der personenbezogenen Daten.`,
  PROFILING: `3.6 Profiling`,
  WIR_F_HREN_KEINE_AUTOMATISIERT: `Wir führen keine automatisierte Entscheidungsfindung bzw. kein Profiling
        gemäß Artikel 22 DSGVO durch. Eine Profilbildung er-folgt nur zur
        Wahrung unserer berechtigten Interessen wie oben beschrieben.`,
  ZUGRIFFSBERECHTIGUNGEN_IM_E: `4. Zugriffsberechtigungen im Endgerät`,
  SOWEIT_FUNKTIONEN_UNSERES_ONLI: `Soweit Funktionen unseres Online-Angebots die Erteilung von
        Berechtigungen zum Zugriff auf Ihr Endgerät (z.B. Zugriff auf
        Standortdaten oder Fotos) erfordern, ist die Erteilung der
        Berechtigungen freiwillig. Sollten Sie jedoch die entsprechenden
        Funktionen nutzen wollen, ist die Ertei-lung der entsprechenden
        Berechtigungen erforderlich, da Sie andernfalls diese Funktionen nicht
        nutzen können. Die Berechtigungen bleiben so lange aktiv, wie Sie diese
        nicht in ihrem Endgerät durch die Deaktivierung der jeweiligen
        Einstellung wieder zurückgesetzt haben.`,
  F_R_DIE_NUTZUNG_DER_UNTER_ZIFF: `Für die Nutzung der unter Ziffer 3.1 (Nutzung der Funktionen)
        erläuterten Funktionen ist die Verwendung der Kamera Ihres Endge-räts
        erforderlich. Sollten Sie die genannten Funktionen nutzen wollen, so ist
        die Erteilung der entsprechenden Berechtigung erfor-derlich, da Sie
        andernfalls diese Funktionen nicht nutzen können. Die grundsätzliche
        Berechtigung zur Verwendung der Kamera bei der Nutzung der oben
        erläuterten Funktionen bleibt so lange aktiv, wie Sie diese nicht in
        ihrem Endgerät durch die Deaktivierung der jeweiligen Einstellung wieder
        zurückgesetzt haben.`,
  COOKIES_UND_VERGLEICHBARE_T: `5. Cookies und vergleichbare Technologien`,
  WIR_VERWENDEN_IM_RAHMEN_DES_ON: `Wir verwenden im Rahmen des Online-Angebots Cookies und vergleichbare
        Technologien, die dazu dienen, mit Ihrem Endgerät zu kommunizieren und
        gespeicherte Informationen auszutauschen (nachfolgend insgesamt
        „Cookies“). Diese Cookies dienen in erster Linie dazu, die Funktionen
        des Online-Angebots nutzbar zu machen. Allgemeine Beispiele, in denen
        der Einsatz von Cookies in diesem Sinne technisch erforderlich ist, sind
        die Speicherung einer Sprachauswahl, von Login-Daten oder einer
        Einkaufs- bzw. Merkliste. Dementsprechend können technisch erforderliche
        Cookies von uns eingesetzt werden, um die unter Ziffer 3.1 beschriebenen
        Verarbeitungen zu ermöglichen und den ordnungsgemäßen und sicheren
        Betrieb des Online-Angebots zu gewährleisten. Die Datenverarbeitung
        erfolgt dann auf Basis des Artikels 6 Absatz 1 Buchstabe b) und f)
        DSGVO, da sie erforderlich ist, um die von Ihnen gewählten Funktionen
        umzusetzen bzw. um unser berechtigtes Interesse an der
        Funktionsfähigkeit des Online-Angebots zu wahren.`,
  SOWEIT_WIR_DAR_BER_HINAUS_COOK: `Soweit wir darüber hinaus Cookies einsetzen sollten, um die Nutzung des
        Online-Angebots zu analysieren und zielgerichtet auf Ihre Interessen
        ausrichten zu können und ggf. auch, um Ihnen interessenbasierte Inhalte
        und Anzeigen bereitstellen zu können, erfolgt dies ausschließlich auf
        Basis Ihrer freiwilligen Einwilligung gemäß Artikel 6 Absatz 1 Buchstabe
        a) DSGVO. Sie haben dann die Möglichkeit, über entsprechende
        Einstellungen im Rahmen des Online-Angebots Ihre entsprechenden
        Einstellungen vorzunehmen. Sie können eine hierüber erteilte
        Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen. Weitere
        Informationen zu den Cookies und zu deren Funktion im Einzelnen sowie zu
        Einstellungs- und Widerrufsmöglichkeiten erhalten Sie in unserer`,
  WENN_SIE_DEN_EINSATZ_VON_COOKI: `Wenn Sie den Einsatz von Cookies insgesamt nicht wünschen, können Sie
        auch deren Speicherung ggf. durch entspre-chende Einstellungen Ihres
        Endgeräts verhindern. Gespeicherte Cookies können Sie in den
        Systemeinstellungen Ihres Endgeräts jederzeit löschen. Bitte beachten
        Sie, dass die Blockierung bestimmter Arten von Cookies zu einer
        beeinträch-tigten Nutzung unseres Online-Angebots führen kann.`,
  EINGEBUNDENE_DRITTDIENSTE: `6. Eingebundene Drittdienste`,
  SOWEIT_WIR_IM_RAHMEN_UNSERES_O: `Soweit wir im Rahmen unseres Online-Angebots Dienste anderer Anbieter
        einbinden, um Ihnen bestimmte Inhalte oder Funktionen zu bieten (z.B.
        das Abspielen von Videos oder eine Routenplanung) und wir dabei
        personenbezogene Daten verarbeiten, erfolgt dies auf Basis des Artikels
        6 Absatz 1 Buchstabe b) und f) DSGVO. Denn die Datenverarbeitung ist
        dann erforderlich, um die von Ihnen gewählten Funktionen umzusetzen bzw.
        um unser berechtigtes Interesse an einem optimalen Funktionsumfang des
        Online-Angebots zu wahren. Soweit im Rahmen dieser Drittdienste
        möglicherweise Coo-kies eingesetzt werden, gelten die Ausführungen unter
        Ziffer 5. Bitte informieren Sie sich in Bezug auf die Drittdienste auch
        über die Datenschutzerklärung des jeweiligen Anbieters.`,
  DIENSTE_ANDERER_ANBIETER_DIE: `Dienste anderer Anbieter, die wir einbinden bzw. auf die von uns
        verwiesen wird, werden von den entsprechenden Dritten bereitgestellt.
        Wir haben grundsätzlich keinen Einfluss auf Inhalt und Funktion der
        Drittdienste und sind für die Verarbeitung Ihrer personenbezogenen Daten
        durch deren Anbieter grundsätzlich nicht verantwortlich, soweit die
        Drittdienste nicht vollständig in unserem Auftrag konzipiert und dann
        von uns in eigener Verantwortlichkeit eingebunden werden. Soweit die
        Einbindung eines Drittdienstes dazu führt, dass wir mit dessen Anbieter
        gemeinsame Prozesse etablieren, legen wir mit diesem Anbieter in einer
        Vereinbarung über die gemeinsame Verantwortlichkeit nach Artikel 26
        DSGVO fest, wie die jeweiligen Aufgaben und Zuständigkeiten bei der
        Verarbeitung personenbezogener Daten ausgestaltet sind und wer welche
        datenschutz-rechtlichen Verpflichtungen erfüllt. Soweit Cookies auch auf
        Basis Ihrer Einwilligung gesetzt werden sollen, erhalten Sie weitere
        Informationen zur Verantwortlichkeit für das Setzen dieser Cookies bzw.
        damit ggf. verbundene Drittdienste im entsprechenden Bereich in der`,
  SOWEIT_NICHT_ANDERS_ANGEGEBEN: `Soweit nicht anders angegeben, werden Profile auf Social Media in
        unserem Online-Angebot grundsätzlich lediglich als Link zu den
        entsprechenden Drittdiensten eingebunden. Nach dem Anklicken des
        eingebundenen Text-/Bild-Links werden Sie auf das Angebot des jeweiligen
        Social-Media-Anbieters weitergeleitet. Nach der Weiterleitung werden
        ggf. personenbezogene Daten direkt durch den Drittanbieter erhoben.
        Sollten Sie währenddessen in Ihrem Benutzerkonto des jeweiligen
        Social-Media-Anbieters eingeloggt sein, kann dieser ggf. die gesammelten
        Informationen des konkreten Besuchs dem persönlichen Benutzerkonto
        zuordnen. Interagieren Sie über einen „Teilen“-Button des jeweiligen
        Social-Media-Anbieters, können diese Informationen in dem persönlichen
        Benutzerkonto gespeichert und ggf. veröffentlicht werden. Möchten Sie
        verhindern, dass die gesammelten Informationen unmittelbar Ihrem
        Benutzerkonto zugeordnet werden, müssen Sie sich vor dem Anklicken des
        eingebundenen Text-/Bild-Links ausloggen.`,
  F_R_DIE_ANALYSE_UND_VERWALTUNG: `Für die Analyse und Verwaltung von In-App-Käufen nutzt Yuu Yoga den
        Dienst RevenueCat (Anbieter: Revenue Cat, Inc., 633 Taraval St. Suite
        101, San Francisco, CA, 94116, USA). Die Übermittlung erfolgt
        DSGVO-konform, analog den Vorschriften des Art. 46 DSGVO. RevenueCat
        speichert bzw. Verarbeitet die Daten und bereitet sie in einer
        Web-Oberfläche auf. Die Daten werden durch RevenueCat in den USA oder
        Europa gespeichert. RevenueCat unterstellt sich der EU-DSGVO (EU
        2016/679) per DPA:`,
  HTTPS_WWW_REVENUECAT_COM_DPA: `https://www.revenuecat.com/dpa`,
  DU_STIMMST_DER_DATENERFASSUNG: `Du stimmst der Datenerfassung durch Yuu Yoga und der Übermittlung der
        Daten an RevenueCat zu. Du kannst die eigenen Daten in Yuu Yoga bzw. bei
        RevenueCat aus der Datenbank löschen lassen, hierzu kannst du eine
        E-Mail an`,
  VERFASSEN_UND_DIE_L_SC: `verfassen und die
        Löschung mit dem Hinweis „Löschung meiner Daten bei RevenueCat“ fordern.
        Wenn dies nicht erfolgt, so werden die Daten spätestens nach den
        gesetzlich vorgeschriebenen Aufbewahrungsfristen gelöscht. Wir verweisen
        auf die Datenschutzbestimmungen und auf die Allgemeinen
        Geschäftsbedingungen von RevenueCat:`,
  DATENSCHUTZBESTIMMUNGEN: `Datenschutzbestimmungen:`,
  HTTPS_WWW_REVENUECAT_COM_PRI: `https://www.revenuecat.com/privacy`,
  ALLGEMEINE_GESCH_FTSBEDINGUNGE: `Allgemeine Geschäftsbedingungen:`,
  HTTPS_WWW_REVENUECAT_COM_TER: `https://www.revenuecat.com/terms`,
  UNTER_FOLGENDEM_LINK_K_NNEN_DI: `Unter folgendem Link können die Daten, die von RevenueCat gespeichert
        und aufbereitet werden, eingesehen werden:`,
  EMPF_NGER_PERSONENBEZOGENER: `7. Empfänger personenbezogener Daten`,
  INNERHALB_UNSERES_UNTERNEHMENS: `Innerhalb unseres Unternehmens haben nur diejenigen Personen Zugriff auf
        Ihre personenbezogenen Daten, die diese für die jeweils genannten Zwecke
        benötigen. An externe Empfänger geben Ihre personenbezogenen Daten nur
        weiter, wenn hierfür eine gesetzliche Erlaubnis besteht oder uns Ihre
        Einwilligung vorliegt. Nachfolgend finden Sie eine Übersicht über die
        entsprechenden Empfänger:`,
  AUFTRAGSVERARBEITER_KONZERN: `- Auftragsverarbeiter: Konzerngesellschaften oder externe Dienstleister,
        beispielsweise in den Bereichen der technischen Infra-struktur und
        Wartung, die sorgfältig ausgewählt und überprüft werden. Die
        Auftragsverarbeiter dürfen die Daten ausschließ-lich nach unseren
        Weisungen verwenden.`,
  FFENTLICHE_STELLEN_BEH_RDE: `- Öffentliche Stellen: Behörden und staatliche Institutionen, wie z.B.
        Steuerbehörden, Staatsanwaltschaften oder Gerichte, an die wir z.B. zur
        Erfüllung rechtlicher Verpflichtungen oder zur Wahrung berechtigter
        Interessen personenbezogene Daten übermitteln (müssen).`,
  PRIVATE_STELLEN_KOOPERATION: `- Private Stellen: Kooperationspartner sowie andere Dienstleister oder
        Personen, an die Daten auf Basis einer Einwilli-gung, zur Durchführung
        eines Vertrages mit Ihnen oder zur Wahrung berechtigter Interessen
        übermittelt werden.`,
  DATENVERARBEITUNG_IN_DRITTL: `8. Datenverarbeitung in Drittländern`,
  FINDET_EINE_DATEN_BERMITTLUNG: `Findet eine Datenübermittlung an Stellen statt, deren Sitz oder deren
        Ort der Datenverarbeitung nicht in einem Mitgliedstaat der Europäischen
        Union, einem anderen Vertragsstaat des Abkommens über den Europäischen
        Wirtschaftsraum oder einem Staat, für den durch einen Beschluss der
        Europäischen Kommission ein angemesse-nes Datenschutzniveau festgestellt
        wurde, gelegen ist, stellen wir vor der Weitergabe sicher, dass die
        Datenübermittlung entweder durch einen gesetzlichen Erlaubnis-tatbestand
        gedeckt ist, Garantien für ein angemessenes Datenschutzniveau in Bezug
        auf die Datenübermittlung bestehen (z.B. durch die Vereinbarung
        vertraglicher Gewährleistungen, behördlich anerkannte Regelungen oder
        verbindliche interne Datenschutzvorschriften beim Empfänger) oder Sie
        Ihre Einwilligung in die Daten-übermittlung erteilt haben.`,
  SOWEIT_DIE_DATEN_BERMITTLUNG_A: `Soweit die Datenübermittlung auf Grundlage von Artikel 46, 47 oder 49
        Absatz 1 Unterabsatz 2 DSGVO erfolgt, können Sie bei uns eine Kopie der
        Garantien für das Bestehen eines angemessenen Datenschutzniveaus in
        Bezug auf die Daten-übermittlung oder einen Hinweis auf die
        Verfügbarkeit einer Kopie der Garantien erhalten. Bitte nutzen Sie
        hierfür die Angaben unter Ziffer 1.`,
  SPEICHERDAUER_L_SCHUNG: `9. Speicherdauer, Löschung`,
  WIR_SPEICHERN_IHRE_PERSONENBEZ: `Wir speichern Ihre personenbezogenen Daten, wenn hierfür eine
        gesetzliche Erlaubnis besteht, nur so lange wie zur Erreichung der
        verfolgten Zwecke erforderlich bzw. solange Sie die Einwilligung nicht
        widerrufen haben. Im Falle eines Widerspruchs gegen die Verarbeitung
        löschen wir Ihre personenbezogenen Daten, es sei denn, die
        Weiterverarbeitung ist nach den gesetzlichen Bestimmungen weiterhin
        erlaubt. Wir löschen Ihre personenbezogenen Daten auch dann, wenn wir
        hierzu aus anderen rechtlichen Gründen verpflichtet sind. Unter
        Anwendung dieser allgemeinen Grundsätze löschen wir Ihre
        personenbezogenen Daten in der Regel unverzüglich`,
  NACH_WEGFALL_DER_RECHTLICHEN: `- nach Wegfall der rechtlichen Grundlage und sofern keine anderweitige
        Rechtsgrundlage (z.B. handels- und steuerrechtliche
        Aufbewah-rungsfristen) eingreift. Falls Letzteres zutrifft, löschen wir
        die Daten nach Wegfall der anderweitigen Rechtsgrundlage;`,
  WENN_IHRE_PERSONENBEZOGENEN: `- wenn Ihre personenbezogenen Daten für die von uns verfolgten Zwecke
        nicht mehr erforderlich sind und keine ander-weitige Rechtsgrundlage
        (z.B. handels- und steuerrechtliche Aufbewahrungsfristen) eingreift.
        Falls Letzteres zutrifft, löschen wir die Daten nach Wegfall der
        anderweitigen Rechtsgrundlage.`,
  BETROFFENENRECHTE: `10. Betroffenenrechte`,
  AUSKUNFTSRECHT_SIE_HABEN_DAS: `Auskunftsrecht: Sie haben das Recht, Auskunft über die von uns zu Ihrer
        Person gespeicherten Daten zu erhalten.`,
  BERICHTIGUNGS_UND_L_SCHUNGSRE: `Berichtigungs- und Löschungsrecht: Sie können von uns die Berichtigung
        falscher Daten und - soweit die gesetzlichen Vorausset-zungen erfüllt
        sind - Löschung Ihrer Daten verlangen.`,
  EINSCHR_NKUNG_DER_VERARBEITUNG: `Einschränkung der Verarbeitung: Sie können von uns - soweit die
        gesetzlichen Voraussetzungen erfüllt sind - verlangen, dass wir die
        Verarbeitung Ihrer Daten einschränken.`,
  DATEN_BERTRAGBARKEIT_SOLLTEN: `Datenübertragbarkeit: Sollten Sie uns Daten auf Basis eines Vertrages
        oder einer Einwilligung bereitgestellt haben, so können Sie bei
        Vorliegen der gesetzlichen Voraussetzungen verlangen, dass Sie die von
        Ihnen bereitgestellten Daten in einem strukturierten, gängigen und
        maschinenlesbaren Format erhalten oder dass wir diese an einen anderen
        Verant-wortlichen übermitteln.`,
  WIDERSPRUCH_SIE_HABEN_DAS_REC: `Widerspruch: Sie haben das Recht, aus Gründen, die sich aus ihrer
        besonderen Situation ergeben, jederzeit der Datenverarbeitung durch uns
        zu widersprechen, soweit diese auf der Wahrung berechtigter Interesse
        beruht. Sofern Sie von Ihrem Widerspruchs-recht Gebrauch machen, werden
        wir die Verarbeitung einstellen, es sei denn, wir können zwingende
        schutzwürdige Gründe für die Weiterverarbeitung nachweisen, welche Ihre
        Rechte und Interessen überwiegen.`,
  WIDERSPRUCH_GEGEN_DIREKTWERBUN: `Widerspruch gegen Direktwerbung: Sofern wir Ihre personenbezogenen Daten
        verarbeiten, um Direktwerbung zu betreiben, haben Sie das Recht,
        jederzeit der Datenverarbeitung durch uns zu diesem Zweck zu
        widersprechen. Sofern Sie von Ihrem Widerspruchsrecht Gebrauch machen,
        werden wir die Verarbeitung zu diesem Zweck einstellen.`,
  WIDERRUF_DER_EINWILLIGUNG_SOF: `Widerruf der Einwilligung: Sofern Sie uns eine Einwilligung in die
        Verarbeitung Ihrer personenbezogenen Daten erteilt ha-ben, können Sie
        diese jederzeit mit Wirkung für die Zukunft widerrufen. Die
        Rechtmäßigkeit der Verarbeitung Ihrer Daten bis zum Widerruf bleibt
        hiervon unberührt.`,
  BESCHWERDERECHT_BEI_DER_AUFSIC: `Beschwerderecht bei der Aufsichtsbehörde: Sie können zudem eine
        Beschwerde bei der zuständigen Aufsichtsbehörde einreichen, wenn Sie der
        Meinung sind, dass die Verarbeitung Ihrer Daten gegen geltendes Recht
        verstößt. Sie können sich hierzu an die Auf-sichtsbehörde wenden, die
        für Ihren Wohnort bzw. Ihr Land zuständig ist oder an die für uns
        zuständige Aufsichtsbehörde.`,
  IHR_KONTAKT_ZU_UNS_UND_DIE_AUS: `Ihr Kontakt zu uns und die Ausübung Ihrer Rechte: Des Weiteren können
        Sie sich bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten und
        zu Ihren Betroffenenrechten unentgeltlich mit uns in Verbindung setzen.
        Wenden Sie sich bitte an`,
  BETROFFENENRECHTE_INITIUM_GMBH: `betroffenenrechte@initium.gmbh`,
  ODER_POSTALISCH_AN_DIE_OBEN_UN: `oder postalisch an die oben unter Ziffer 1 angegebene Anschrift. Bitte
        stellen Sie dabei sicher, dass uns eine eindeutige Identifizierung Ihrer
        Person möglich ist. Beim Widerruf der Einwilligung können Sie alternativ
        auch den Kontaktweg wählen, den Sie bei der Abgabe der Einwilligung
        ver-wendet haben.`,
  STAND: `11. Stand`,
  ES_GILT_DIE_AKTUELLSTE_VERSION: `Es gilt die aktuellste Version dieser Datenschutzerklärung. Stand
        12.10.2021.`,
  AUF_DER_WEBSEITE_WWW_YUUXYOGA: `Auf der Webseite www.yuuxyoga.de („`,
  WEBSEITE: `Webseite`,
  SOWIE_MIT_MIT_MIT_MIT_MIT_M: `”) sowie mit mit mit mit mit mittels einer Applikation („`,
  APP: `App`,
  BIETET_DIE_INITIUM_GMBH_ST: `”) bietet die Initium GmbH, Stralauer Allee 12, 10245 Berlin,
        Deutschland („`,
  WIR: `Wir`,
  EINE_PLATTFORM_DIE_ES_DEM: `“) eine Plattform, die es dem Nutzer („`,
  DU: `Du`,
  IM_RAHMEN_DES_NACHFOLGEND_B: `“) im Rahmen des nachfolgend beschriebenen Leistungsumfang ermöglicht,
        Workouts mit Übungsanleitungen verschiedener Trainer anzusehen und diese
        im Rahmen Deines eigenen Workouts zu wiederholen („`,
  YUUYOGA: `YuuYoga`,
  EINE_NUTZUNG_VON_YUUYOGA_S: `“). Eine Nutzung von YuuYoga setzt voraus, dass Du diesen
        Nutzungsbedingungen zustimmst, die Gegenstand des zwischen uns und Dir
        geschlossenen Nutzungsvertrags sind. Lies daher diese
        Nutzungsbedingungen sorgfältig durch und mache Dich mit den hierin
        vorgesehenen Regelungen vertraut.`,
  LEISTUNGSGEGENSTAND_VON_YUU: `1. Leistungsgegenstand von YuuYoga`,
  YUUYOGA_BIETET_DIR_DIE_M_GLICH: `YuuYoga bietet Dir die Möglichkeit, auf eine Bibliothek von
        Video-Inhalten wie Yoga Workouts, Übungen und Trainings („`,
  WORKOUTS: `Workouts`,
  VON_AUSGEW_HLTEN_LEHRERN: `“) von ausgewählten Lehrern („`,
  TRAINER: `Trainer`,
  ZUZUGREIFEN_UND_W_HREND_UND: `“) zuzugreifen und während und nach einer durchgeführten Einheit
        personalisiertes Feedback über die Art der Ausführung zu erhalten.`,
  DAS_PERSONALISIERTE_FEEDBACK: `Das personalisierte Feedback, erfolgt dergestalt, dass Du über das
        Aufstellen und Verknüpfen von Kameras Deines Endgerätes (z.B.
        Smartphone, Tablet, Laptop etc.) einen virtuellen Spiegel angezeigt
        bekommst („`,
  UND_SO_W_HREND_UND_NACH_EIN: `“) und so während und nach einer Session einen direkten Vergleich Deiner
        Ausführung von Übungen zu der Ausführung der Trainer erhältst.`,
  DIE_NUTZUNG_VON_YUUYOGA_ERFORD: `Die Nutzung von YuuYoga erfordert, dass Du gegebenenfalls weitere
        Verträge mit Dritten schließen bzw. geschlossen hast (z.B. mit Deinem
        Mobilfunkanbieter); daraus entstehende Kosten – insbesondere für in
        Anspruch genommenes Datenvolumen – hast Du zu tragen.`,
  ZUR_VOLLUMF_NGLICHEN_NUTZUNG_V: `Zur vollumfänglichen Nutzung von YuuYoga werden ggf. Hilfsmittel wie ein
        Endgerät oder Trainingsgeräte benötigt. Diese sind nicht Teil des
        YuuYoga Angebots und müssen von Dir gegebenenfalls separat und auf
        eigene Kosten erworben werden.`,
  VORAUSSETZUNGEN_F_R_DIE_NUT: `2. Voraussetzungen für die Nutzung von YuuYoga`,
  DU_KANNST_YUUYOGA_NUTZEN_WENN: `Du kannst YuuYoga nutzen, wenn Du eine natürliche Person bist, die das
        18. Lebensjahr vollendet hat. Bitte beachte außerdem, dass für die
        Nutzung von YuuYoga erforderlich ist, dass Du über ein Apple Endgerät
        mit mindestens dem Betriebssystem IOS 8 verfügst.`,
  SOWEIT_DU_DICH_F_R_EIN_KOSTENP: `Soweit Du Dich für ein kostenpflichtiges Abonnements entscheidest, ist
        die Zahlung der Vergütung an uns für die weitere Nutzung von Yuu Yoga
        erforderlich.. Die Einrichtung eines Nutzerkontos erfolgt durch Angabe
        einer E-Mail-Adresse und`,
  DER_FESTLEGUNG_EINES_PASSWORTS: `der Festlegung eines Passworts oder`,
  DER_VERWENDUNG_EINES_NUTZERPRO: `der Verwendung eines Nutzerprofils bei einem von Dritten betriebenen
        (sozialen) Netzwerk, wie etwa Facebook, Google oder LinkedIn („`,
  SOCIAL_LOGIN: `Social Login`,
  SOFERN_DU_DICH_MITTELS_SOC: `“); sofern Du Dich mittels Social Login bei YuuYoga registrieren
        möchtest, wirst Du auf die Login-/Anmelde-Maske des Drittanbieters
        weitergeleitet und kannst Dich dort mit Deinem bei diesem Drittanbieter
        hinterlegten Benutzernamen und Passwort anmelden („`,
  ZUGANGSDATEN: `Zugangsdaten`,
  DU_HAST_DAF_R_SORGE_ZU_TRAGEN: `Du hast dafür Sorge zu tragen, dass die verwendeten Zugangsdaten vor dem
        Zugriff Dritter geschützt sind und sorgfältig aufbewahrt werden. Sofern
        Du Grund zu der Annahme hast, dass die Vertraulichkeit Deines Passworts
        beeinträchtigt wurde oder unberechtigter Zugriff auf Dein Nutzerkonto
        auf andere Weise möglich ist, verpflichtest Du Dich, unverzüglich Dein
        Passwort zu ändern und Uns zu benachrichtigen.`,
  WIR_HABEN_DAS_RECHT_VON_ZEIT: `Wir haben das Recht, von Zeit zu Zeit Änderungen des Passworts
        anzufordern. Wir können den Zugriff auf das Nutzerkonto sperren, bis
        eine solche Änderung des Passworts vorgenommen wurde.`,
  NACH_EINRICHTUNG_DES_NUTZERKON: `Nach Einrichtung des Nutzerkontos kannst Du zudem einen Benutzernamen
        festlegen. Hinsichtlich der Wahl des Benutzernamens verpflichtest Du
        dich dazu, die berechtigten Interessen Dritter zu wahren und keinen
        Benutzernamen zu wählen, der beleidigend, anstößig, diskriminierend,
        Gewalt verherrlichend, verleumderisch oder irreführend ist, eine
        gesetzeswidrige Handlung fördert oder unterstützt oder sonst gegen
        geltendes Recht verstößt. Bei einem Verstoß gegen diese Grundsätze
        behalten Wir Uns vor, Dich auch nachträglich zur Änderung Deines
        Benutzernamens aufzufordern. In diesem Fall können Wir Deinen Zugang zum
        Nutzerkonto gemäß Ziffer 6 sperren, bis eine Änderung des Benutzernamens
        vollzogen ist.`,
  IM_RAHMEN_VON_YUUYOGA_WERDEN_D: `Im Rahmen von YuuYoga werden Dir Übungsanleitungen gezeigt (z.B. für
        bestimmte Übungen und Trainings). Diese Anleitungen müssen in jedem Fall
        durch Dich eingehalten werden, da ansonsten Verletzungs- und oder
        Gesundheitsrisiken bestehen.`,
  WIR_WEISEN_DICH_DARAUF_HIN_DA: `Wir weisen Dich darauf hin, dass Yuu Yoga nicht deine individuelle
        Sportlichkeit, Beweglichkeit oder Belastungsgrenze ermittelt. Auch ist
        Uns Dein Gesundheitszustand nicht bekannt. Deshalb erfolgt die
        Durchführung der Sessions bei YuuYoga auf eigenes Risiko. Bitte stelle
        daher sicher, dass Du YuuYoga nur nutzt, wenn Du über einen guten
        körperlichen und gesundheitlichen Zustand verfügst. Wir möchten Dich
        hinweisen, dass YuuYoga nicht genutzt werden sollte, wenn Du
        beispielsweise starke Schmerzen, allgemeines Unwohlsein, Kurzatmigkeit,
        Übelkeit oder Schwindel verspürst. Sollten bereits bei Dir
        Vorerkrankungen bestehen oder bekannt sein, so hole bitte vor der
        Nutzung von YuuYoga ärztlichen Rat ein und befolge diese Empfehlungen.
        Dies gilt insbesondere, wenn Du unter Herz-/Kreislauferkrankungen,
        Wirbelsäulen, Gelenkproblemen, und/oder anderen Einschränkungen
        gesundheitlicher Art leidest, die Deine sportliche Leistungsfähigkeit
        einschränken.`,
  VERF_GBARKEIT_FUNKTIONALIT: `3. Verfügbarkeit, Funktionalitäten und Anpassungen`,
  WIR_BIETEN_DIE_M_GLICHKEIT_ZUR: `Wir bieten die Möglichkeit zur Nutzung von YuuYoga nur mit den
        wesentlichen Funktionalitäten, welche in Ziffer 1 beschrieben sind.
        Hiervon ausgenommen sind unwesentliche Funktionalitäten sowie Zeiträume
        für geplante Wartungen, Updates, Upgrades etc.`,
  WIR_SIND_BERECHTIGT_YUUYOGA_U: `Wir sind berechtigt, YuuYoga und seine Funktionalitäten jederzeit und
        ohne Vorankündigung anzupassen („`,
  ANPASSUNGEN: `Anpassungen`,
  VORAUSGESETZT_DASS_YUUYOGA: `“), vorausgesetzt dass YuuYoga den in Ziffer 1 beschriebenen
        Leistungsumfang weiterhin grundsätzlich beibehält und solche Anpassungen
        Dir zumutbar sind. Zu Anpassungen sind Wir allerdings nicht
        verpflichtet. Anpassungen können dazu führen, dass Du zur Weiternutzung
        von YuuYoga eine aktuelle Version der App installieren musst oder dass
        ein bisher genutztes Endgerät zur Nutzung von YuuYoga nicht mehr
        geeignet ist.`,
  GEISTIGES_EIGENTUM_UND_ANDE: `4. Geistiges Eigentum und andere Schutzrechte`,
  WIR_BEHALTEN_UNS_AN_YUUYOGA_UN: `Wir behalten Uns an YuuYoga und den im Rahmen von YuuYoga dargestellten
        Inhalten sämtliche Urheber- und sonstigen Schutzrechte vor, soweit uns
        diese zustehen. Du darfst YuuYoga und die darin dargestellten Inhalte
        nur für eigene persönliche und nicht-kommerzielle Zwecke verwenden. Jede
        Nutzung von YuuYoga und den darin dargestellten Inhalten für
        kommerzielle Zwecke (z.B. zur eigenen Gewinnerzielung) ist untersagt,
        soweit Wir nicht im Einzelfall schriftlich zugestimmt haben.`,
  HINWEISE_UND_ANGABEN_ZU_URHEBE: `Hinweise und Angaben zu Urheberrechten, Markenrechten oder anderen
        Rechten geistigen Eigentums an YuuYoga und den Inhalten dürfen nicht
        verändert oder entfernt werden.`,
  VERTRAGSDAUER_UND_K_NDIGUNG: `5. Vertragsdauer und Kündigung`,
  DER_ZWISCHEN_DIR_UND_UNS_GESCH: `Der zwischen Dir und Uns geschlossene Nutzungsvertrag läuft für eine
        unbestimmte Zeit.`,
  DU_KANNST_DEN_NUTZUNGSVERTRAG: `Du kannst den Nutzungsvertrag jederzeit ohne Einhaltung einer
        Kündigungsfrist sowie ohne Vorliegen und Angabe eines Grundes kündigen.
        Dies kann auch durch Löschung Deines Nutzerkontos erfolgen. Bei
        Abschluss eines kostenpflichtigen Abonnements ist, abweichend von Satz 1
        und 2, eine Kündigung erst zum Ablauf der Mindestvertragslaufzeit des
        jeweiligen Abonnements möglich..`,
  WIR_K_NNEN_DEN_NUTZUNGSVERTRAG: `Wir können den Nutzungsvertrag nur unter Einhaltung einer angemessenen
        Frist ordentlich kündigen.`,
  DAS_RECHT_JEDER_PARTEI_ZUR_AUS: `Das Recht jeder Partei zur außerordentlichen fristlosen Kündigung aus
        wichtigem Grund sowie Unser Recht zur Sperrung Deines Zugriffs auf Dein
        Nutzerkonto bleiben unberührt.`,
  AB_WIRKSAMWERDEN_EINER_K_NDIGU: `Ab Wirksamwerden einer Kündigung löschen Wir Dein Nutzerkonto`,
  SPERRUNG_DES_NUTZERKONTOS: `6. Sperrung des Nutzerkontos`,
  WIR_K_NNEN_DIR_DEN_ZUGRIFF_AUF: `Wir können Dir den Zugriff auf Dein Nutzerkonto vorübergehend sperren,
        wenn Wir feststellen oder begründeten Verdacht haben, dass Deine Nutzung
        von YuuYoga gegen diese Nutzungsbedingungen und/oder gegen geltendes
        Recht verstößt,`,
  RECHTE_DRITTER_VERLETZT: `Rechte Dritter verletzt,`,
  EIN_SICHERHEITSRISIKO_F_R_DIE: `ein Sicherheitsrisiko für die Funktionsfähigkeit von YuuYoga darstellt,`,
  YUUYOGA_UND_ODER_ANDERE_NUTZER: `YuuYoga und/oder andere Nutzer einer Haftung unterwerfen könnte, oder`,
  BETR_GERISCH_SEIN_K_NNTE: `betrügerisch sein könnte.`,
  WIR_BEHALTEN_UNS_EINE_SPERRUNG: `Wir behalten Uns eine Sperrung Deines Zugriffs auf Dein Nutzerkonto auch
        dann vor, wenn Du einer zumutbaren Änderung dieser Nutzungsbedingungen
        gemäß Ziffer 10.1 bis zum geplanten Termin von deren Wirksamwerden nicht
        zugestimmt hast.`,
  WIR_WERDEN_DIE_SPERRUNG_AUFHEB: `Wir werden die Sperrung aufheben, sobald der Grund der Sperrung nicht
        länger fortbesteht. Zu diesem Zweck kannst Du Uns gerne unter`,
  INFOA_YUUXYOGA_DE: `infoa@yuuxyoga.de`,
  KONTAKTIEREN_UM_EINE_KL_RUNG: `kontaktieren, um eine Klärung herbeizuführen.`,
  WEITERGEHENDE_ANSPR_CHE_GEGEN: `Weitergehende Ansprüche gegen Dich bleiben unberührt.`,
  HAFTUNGSBESCHR_NKUNG: `7. Haftungsbeschränkung`,
  WIR_HAFTEN_GLEICH_AUS_WELCHE: `Wir haften – gleich aus welchem Rechtsgrund – uneingeschränkt`,
  BEI_VORSATZ_ODER_GROBER_FAHRL: `bei Vorsatz oder grober Fahrlässigkeit,`,
  BEI_VORS_TZLICHER_ODER_FAHRL_S: `bei vorsätzlicher oder fahrlässiger Verletzung des Lebens, des Körpers
        oder der Gesundheit,`,
  BEI_FEHLEN_EINER_GARANTIERTEN: `bei Fehlen einer garantierten Beschaffenheit oder bei arglistig
        verschwiegenen Mängeln, sowie`,
  AUFGRUND_ZWINGENDER_HAFTUNG_WI: `aufgrund zwingender Haftung wie etwa nach dem Produkthaftungsgesetz.`,
  BEI_FAHRL_SSIG_VERURSACHTEN_SA: `Bei fahrlässig verursachten Sach- und Vermögensschäden ist Unsere
        Haftung beschränkt auf Fälle der Verletzung einer wesentlichen
        Vertragspflicht, sowie der Höhe nach auf den vertragstypischen,
        vorhersehbaren Schaden begrenzt, soweit gemäß vorstehender Ziffer 7.1
        keine unbeschränkte Haftung besteht. Wesentliche Vertragspflichten sind
        Pflichten, die der Nutzungsvertrag Uns seinem Inhalt nach zur Erreichung
        des Vertragszwecks auferlegt, deren Erfüllung die ordnungsgemäße
        Durchführung des Vertrags überhaupt erst ermöglicht und auf deren
        Einhaltung Du als Nutzer regelmäßig vertrauen darfst.`,
  IM_BRIGEN_IST_EINE_HAFTUNG_VO: `Im Übrigen ist eine Haftung von Uns ausgeschlossen.`,
  VORSTEHENDE_HAFTUNGSREGELUNGEN: `Vorstehende Haftungsregelungen gelten auch im Hinblick auf Unsere
        Haftung für Unsere Erfüllungsgehilfen, Mitarbeiter und gesetzlichen
        Vertreter.`,
  GESETZLICHE_GEW_HRLEISTUNGSANS: `Gesetzliche Gewährleistungsansprüche werden durch diese
        Haftungsregelungen nicht berührt.`,
  DATENSCHUTZ: `8. Datenschutz`,
  DIE_VERARBEITUNG_PERSONENBEZOG: `Die Verarbeitung personenbezogener Daten durch Uns in Bezug auf YuuYoga
        richtet sich nach Unserer Datenschutzerklärung, die Du hier einsehen
        kannst:`,
  ALTERNATIVE_STREITBEILEGUNG: `9. Alternative Streitbeilegung`,
  WIR_SIND_NICHT_BEREIT_ODER_VER: `Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.`,
  SCHLUSSVORSCHRIFTEN: `10. Schlussvorschriften`,
  ANPASSUNGEN_VON_YUUYOGA_SOWIE: `Anpassungen von YuuYoga sowie Änderungen gesetzlicher Rahmenbedingungen
        können es erforderlich machen, dass Wir diese Nutzungsbedingungen
        ändern. Wir werden Dich im Fall einer geplanten Änderung dieser
        Nutzungsbedingungen über den Inhalt der Änderung mindestens vier (4)
        Wochen vor dem geplanten Termin des Wirksamwerdens informieren; die
        geänderten Nutzungsbedingungen werden Dir gegenüber in diesem Fall nur
        wirksam, wenn Du den Änderungen zugestimmt hast.`,
  DU_BIST_NICHT_BERECHTIGT_DEN: `Du bist nicht berechtigt, den Nutzungsvertrag ohne vorherige
        schriftliche Zustimmung von Uns an Dritte zu übertragen.`,
  DER_NUTZUNGSVERTRAG_UNTERLIEGT: `Der Nutzungsvertrag unterliegt dem Recht der Bundesrepublik Deutschland
        unter Ausschluss des UN-Kaufrechts. Gerichtsstand für
        vermögensrechtliche Streitigkeiten aus oder im Zusammenhang mit diesem
        Nutzungsvertrag ist Stuttgart, sofern Du als zu verklagende Partei
        Deinen Wohnsitz oder gewöhnlichen Aufenthalt an einen Ort außerhalb der
        Bundesrepublik Deutschland verlegt hast oder Uns Dein Wohnsitz oder
        gewöhnlicher Aufenthalt im Zeitpunkt der Klageerhebung nicht bekannt
        ist.`,
  MEINE_ACCOUNT_LOSEN: 'Ich möchte meinen Account löschen',
  LOGE_DICH: 'logge dich jetzt ein.',
  LOGIN_GOOGLE: 'Mit Google Einloggen',
  LOGIN_FACEBOOK: 'Mit Facebook Einloggen',
  LOGIN_APPLE: 'Mit Apple Einloggen',
  EMAIL_ADDRESS: 'E-Mail Adresse',
  PASSWORD: 'Passwort',
  CLIENT: 'Client',

  VERGESSEN: 'vergessen?',
  ODER: 'oder',
  NO_ACCOUNT: 'Du hast noch keinen Account?',
  THIRTY_DAYS_CHALLANGE_UNFINISHED:
    'Leider hast Du die Challenge nicht komplett abgeschlossen. Möchtest Du neu starten?',
  ACHIEVED_DAILY_GOAL: 'Tagesziel erreicht!',
  SESSION_FINISHED: 'Du hast für heute Deine Session abgeschlossen',
  BACK: 'Zurück',
  LANGUAGE: 'Language',
  RESTART_CHALLENGE: 'Challenge neu starten',
  YOUR_PROGRESS: 'Dein Fortschritt',
  COURSE_WAITING: 'Das erwartet dich',
  POSE_INFO: 'Mehr über die Pose',
  SESSIONS: 'Sessions',
  AVAILABLE_SOON: 'Bald für Dich verfügbar',
  LEVEL: 'Level',
  POSE_COMPARISON_EXAMPLE: 'Pose Comparison Beispiel',
  YOUR_SMARTPHONE_BACAME: 'Dein Smartphone wird',
  SMART_MIRROR2: 'zum digitalen Spiegel.',
  HOW_TO_POSITION_SMART_MIRROR:
    'Positioniere den SmartMirror so zur Matte, dass Du Dich selbst während der Session in der gleichen Ausrichtung wie die Trainerin sehen kannst.',
  PROPER_POSITION_HELP_YOU_IMPROVE:
    'Damit kannst Du Deine Ausführung selbst direkt während der Session überprüfen und verbessern.',
  YOUR_FIRST_SESSION: 'Deine erste Session',
  WITH_FEEDBACK: 'mit aktivem Feedback',
  START_SESSION: 'Session starten',
  POSE_COMPARSION: 'Pose Comparison',
  IMPROVE_YOUR_PROGRRESS: 'Mach Deinen Fortschritt sichtbar.',
  WE_ARE_TAKING_PHOTOS:
    'Während ausgewählten Posen in der Session, machen wir ein Bild von Dir. Dadurch kannst Du nach der Session in Ruhe Deine Ausführung direkt mit der Trainerin vergleichen.',
  COUTDOWN_BEFORE_EACH_POSE:
    'Vor jeder Pose erscheint ein Countdown. Dadurch weißt Du, wann die nächste Pose Comparison aufgenommen wird.',
  SETTINGS: 'Einstellungen',
  CHOOSE_SIEZE: 'Größe auswählen',
  LARGE: 'Groß',
  MEDIUM: 'Mittel',
  SMALL: 'Klein',
  MIRROR_REPRESENTAION: 'Darstellung spiegeln',
  MIRROR_VIEW: 'Smart Mirror Bild spiegeln',
  AUDIO_COUNTDOWN: 'Pose Comparison Audio Countdown',
  AUDIO_COUNTDOWN_ON: 'Aktiv',
  SMART_MIRROR_HIDE: 'SmartMirror verstecken/anzeigen',
  SMART_MIRROR_ON: 'Anzeigen',
  GRATULATIONS: 'Namaste',
  THANKS_FOR_SETTINGS: 'Danke für die tolle Session!',
  NEXT_SESSION_WAITING: 'Weiter geht’s? Die nächste Session wartet…',
  SESSION_DATA_MISSING:
    'Fehler: Die Pose Comparison für diese Session ist leider nicht verfügbar. Wahrscheinlich wurde kein Foto aufgenommen.',
  WHY_DO_YOU_WANT_DELETE: 'Aus welchem Grund möchtest Du diese Pose löschen?',
  QUESTION_1_HEADLINE: 'Ich kann mich nicht richtig sehen / falsches Timing.',
  QUESTION_1_ANSWEAR:
    'Das das Timing manchmal nicht stimmt kann passieren. Über die Serienbild-Aufnahme hast du aber die einfache Möglichkeit den optimalen Zeitpunkt selbst zu bestimmen. Nutze hierfür einfach die Pfeile links unten im Bild. Sollte in der Serie immer noch keine passende Comparison dabei sein, versuche den selben Flow mehrere Male zu machen, um mit dem Flow der Asanas noch vertrauter zu werden.',
  QUESTION_2_HEADLINE: 'Die Bildqualität ist nicht ausreichend.',
  QUESTION_2_ANSWEAR:
    'Die Qualität der Bilder hängt natürlich von verschiedenen Faktoren ab. Je nach Smartphone und Umgebung kann diese sehr unterschiedlich ausfallen. Wenn du mit der Bildqualität unzufrieden bist, versuche vielleicht bei der nächsten Session die Position deines Setups zu verändern. Achte zum Beispiel darauf, dass die Ausleuchtung gut ist (kein Gegenlicht, nicht zu dunkel) und nimm dir Zeit Dein Smartphone richtig zu positionieren.',
  QUESTION_3_HEADLINE: 'Ich fühle mich unwohl mit diesem Bild.',
  QUESTION_3_ANSWEAR:
    'Keine Sorge. Die Pose Comparison ist nicht nur dafür da möglichst gut auszusehen, sondern soll dir dabei helfen besser zu werden und zu verstehen, wo du deine Ausführung noch verbessern kannst. Wenn du deine Posen über einen längeren Zeitraum sammelst helfen dir diese darüber hinaus noch durch “My Progress” deinen Fortschritt über die Zeit hinweg sichtbar zu machen.',
  QUESTION_4_HEADLINE:
    'Ich möchte nicht, dass Bilder von mir gespeichert werden.',
  QUESTION_4_ANSWEAR:
    'Natürlich kannst du Dein Bild löschen, allerdings musst du dir im Bezug auf deine Privatsphäre keine Sorgen machen. Deine Bilder sind bei Yuu Yoga 100% privat und sicher. Sie können von niemandem außer dir gesehen werden. Darüber hinaus hat das Thema Sicherheit bei uns oberste Priorität.',
  CANCEL: 'Abbrechen',
  DELETE_POSE: 'Pose löschen',
  SAVE: 'Speichern',
  EDIT: 'Bearbeiten',
  START_OUR_COURSESS: 'Starte jetzt mit einem unserer Kurse',
  REMOVE_FROM_FAVORITES: 'von Favoriten entfernen',
  ADD_TO_FAVORITES: 'Zu Favoriten hinzufügen',
  READ_MORE: 'Mehr lesen +',
  READ_LESS: 'Weniger lesen -',
  PROPS: 'Props',
  THATS_WAITS_FOR_YOU: 'Das erwartet Dich',
  ERROR: 'Fehler',
  INSTRUCTOR_NOT_FOUND: 'Fehler: Nicht gefunden.',
  ABOUT: 'Über',
  COURSES_WITH: 'Kurse von',
  DAY_AFTER_DAY: 'Tag für Tag',
  APP_PAGE_TITLE: 'Yuu Yoga',
  CONNECT_PAGE_TITLE: 'Yuu Yoga - Connect',
  CONNECT_YPOUR_PHONE: 'Verbinde Dein Phone',
  SCAN_QR_CODE: 'Scanne den Code mit der',
  ON_YOUR_IOS_DEVICE: 'auf Deinem iOS-Gerät.',
  CAMERA_APP: 'Kamera-App',
  SORRY_2: 'Sorry!',
  SOMETHING_WENT_WRONG: 'Da hat wohl etwas nicht funktioniert!',
  AUTH_NETWORK_ERROR:
    'Keine Internetverbindung. Prüfe dein Netzwerk und versuche es erneut.',
  AUTH_RATE_LIMIT_ERROR:
    'Zu viele Versuche. Warte einige Minuten und versuche es erneut.',
  AUTH_SESSION_EXPIRED:
    'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.',
  AUTH_UNEXPECTED_ERROR:
    'Der Vorgang konnte nicht abgeschlossen werden. Versuche es erneut. Fehlercode: {{code}}.',
  VOUCHER_NETWORK_ERROR:
    'Der Gutschein konnte wegen fehlender Verbindung nicht geprüft werden. Versuche es erneut.',
  VOUCHER_SERVICE_ERROR:
    'Der Gutscheinservice ist vorübergehend nicht verfügbar. Versuche es später erneut.',
  ACCOUNT_CREATED_CODE_SEND_FAILED:
    'Dein Konto wurde erstellt, aber der Codeversand konnte nicht abgeschlossen werden. Melde dich an und wähle „Code erneut senden“.',
  CHECK_EMAIL_INBOX: 'Prüfe deinen Posteingang',
  EMAIL_DELIVERY_UNCONFIRMED:
    'Der Versand dauert länger als gewöhnlich. Prüfe deinen Posteingang. Falls kein Code angekommen ist, versuche es erneut.',
  TRY_AGAIN: 'Erneut versuchen',
  CONTACT_US: 'Melde dich gerne bei uns und wir helfen dir weiter',
  INFO_MAIL: 'info@yuuxyoga.de',
  COOKIE_NAME: 'Name des Cookies',
  COOKIE_TYPE: 'Typ',
  COOKIE_PERIOD: 'Speicherdauer',
  COOKIE_COMPANY: 'Anbieter',
  COOKIE_AIM: 'Zweck',
  COOKIE_LEGAL_BASIS: 'Rechtsgrundlage',
  COOKIE_TABLE: [
    [
      'cookie_acceptance',
      'Permanent',
      '2 Wochen',
      'Porsche Digital',
      'YuuYoga Webseite – Information, ob Cookies akzeptiert werden',
      'Art. 6 Abs. 1 f) DSGVO',
    ],
    [
      '_ga',
      'Permanent',
      '2 Jahre',
      'Google Analytics',
      'Google Analytics Cookie zur Nutzeridentifikation; siehe auch https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage',
      'Art. 6 Abs. 1 a) DSGVO',
    ],
    [
      '_gid',
      'Permanent',
      '1 Tag',
      'Google Analytics',
      'Google Analytics Cookie zur Nutzeridentifikation.',
      'Art. 6 Abs. 1 a) DSGVO',
    ],
    [
      '_gat_gtag',
      'Permanent',
      '1 Min',
      'Google Analytics',
      'Google Analytics Cookie zur Drosselung der Requestanzahl.',
      'Art. 6 Abs. 1 a) DSGVO',
    ],
    [
      '_fbp',
      'Permanent',
      '90 Tage',
      'Facebook',
      'Über den Facebook Pixel können wir statistisch nachvollziehen, welche Werbung zu einem Besuch unserer Website bzw. App geführt hat. Mehr Details weiter oben unter Marketing.',
      'Art. 6 Abs. 1 a) DSGVO',
    ],
    [
      'fs_uid',
      'Permanent',
      '1 Jahr',
      'FullStory',
      'FullStory Cookie zur Nutzeridentifikation.',
      'Art. 6 Abs. 1 a) DSGVO',
    ],
  ],
  LOGIN_PAGE_META_TITLE: 'Yuu Yoga - Anmelden',
  RESSET_YOUR_PASSWORD: 'Passwort zurücksetzen',
  CONFIRM_RESET_PASSWORD: 'Neues Passwort speichern',
  CONFIRM_ACCOUT_FIRST: 'Bitte bestätige zunächst deinen Benutzer.',
  USER_NOT_FOUND: 'Dieser Benutzer existiert noch nicht',
  REGISTER_BUTTON_LINK: 'Zur Registrierung',
  INVALID_PASSWORD: 'Ungültiges Passwort.',
  INVALID_LOGIN_OR_PASSWORD: 'Ungültige E-Mail Adresse oder Passwort',
  EMAIL_SENT: 'Wir haben dir eine E-Mail gesendet',
  ENTER_CODE_FROM_EMAIL:
    "Bitte gib' als nächstes den Code aus der E-Mail ein, um deine E-Mail Adresse zu bestätigen.",
  ENTER_THE_CODE: 'Code eingeben',
  PASSWORD_NOT_MEET_REQUIREMENTS:
    'Das Passwort entspricht nicht den Anforderungen. Es dürfen nur Zahlen, Buchstaben und diese Zeichen verwendet werden:',
  EMAIL_INVALID: 'Ungültiges Format',
  USER_ALREADY_EXISITS: 'Dein Benutzer existiert bereits.',
  LOGIN_BUTTON_LINK: 'Zum Login',
  ACTIVATION_CODE_INVALID: 'Der Code ist ungültig.',
  FEEL_FREE_TO_CONTACT_US:
    'Melde dich gerne bei uns und wir helfen dir weiter:',
  CODE_EXPIRED: 'Dein Code ist abgelaufen.',
  EMAIL_NOT_FOUND: 'Diese E-Mail Adresse existiert nicht.',
  ACTIVATION_SUCCESFULL: 'Aktivierung erfolgreich.',
  ACCOUNT_ACTIVATED:
    'Deine E-Mail Adresse wurde erfolgreich aktiviert, du kannst dich nun anmelden.',
  ENTER_CODE_TO_CHANGE_PASSWORD:
    "Bitte gib' als nächstes den Code aus der E-Mail ein, um ein neues Passwort festzulegen.",
  CONTACT_US_IF_YOU_HAVENT_RECIEVE_EMAIL:
    'Falls du keine E-Mail erhalten hast, melde dich gerne bei uns:',
  CONFIRM_ACCOUNT_FIRST: 'Bitte bestätige zunächst deinen Benutzer.',
  PASSWORD_CHANGED: 'Passwort erfolgreich geändert.',
  PASSWORD_CHANGED_SUCCESSFULLY:
    'Dein Passwort wurde erfolgreich geändert, du kannst dich nun anmelden.',
  CODE_FROM_EMAIL: 'Code aus der E-Mail',
  FREE_REGISTER_BUTTON: 'Kostenlos registrieren',
  CONSENT: 'Ich stimme den',
  TERMS_OF_USE: 'Nutzungsbedinungen',
  ACCEPT: 'zu und nehme die ',
  PRIVACY_POLICY: 'Datenschutzbestimmungen',
  PRIVACY_POLICY_2: 'zur Kenntnis.',
  MARKETING_CONSENT:
    'Ich möchte E-Mails zu Neuigkeiten von Yuu Yoga erhalten und erteile meine jederzeit widerrufbare Einwilligung in die Nutzung meiner Daten zu diesem Zweck.',
  CONFIRM_BUTTON: 'Bestätigen',
  ALREADY_HAVE_AN_ACCOUNT: 'Du hast schon einen Account?',
  PRIVACY_PLOLICY_PAGE_TITLE: 'Datenschutzerklärung',
  TERMS_OF_USE_PAGE_TITLE: 'Nutzungsbedingungen',
  GOAL_OPTIONS_LABELS: {
    '30_days_challenge': '30-Day Challenge',
    headstand: 'Kopfstand lernen',
    basics: 'Die Basics lernen',
    other: 'Anderes Ziel',
    health_care: 'Achten Sie auf Ihre körperliche Gesundheit',
    twine: 'Mach die Schnur',
    improve_mobilitiy: 'Körperbeweglichkeit verbessern',
    gear_up: 'stärker werden',
    imprive_condition: 'Verbessern Sie den Zustand',
    get_rid_of_tensions: 'Befreien Sie sich von Spannungen',
    get_rid_of_stress: 'Stress reduzieren',
    relax: 'Ruhe suchen (Entspannung und Meditation hier)',
    be_young: 'Jugend bewahren',
  },
  GOAL_OPTIONS_NAMES: {
    '30_days_challenge': '',
    headstand: 'Kopfstand',
    basics: 'Basics',
    other: '',
    health_care: 'Achten Sie auf Ihre körperliche Gesundheit',
    twine: 'Mach die Schnur',
    improve_mobilitiy: 'Körperbeweglichkeit verbessern',
    gear_up: 'stärker werden',
    imprive_condition: 'Verbessern Sie den Zustand',
    get_rid_of_tensions: 'Befreien Sie sich von Spannungen',
    get_rid_of_stress: 'Stress reduzieren',
    relax: 'Ruhe suchen (Entspannung und Meditation hier)',
    be_young: 'Jugend bewahren',
  },
  GOAL_OPTIONS_TITLES: {
    '30_days_challenge': 'Meine 30 Day Challenge',
    headstand: 'Mein Weg zum Kopfstand.',
    basics: 'Starte jetzt mit den Basics.',
    other: '',
    health_care: 'Achten Sie auf Ihre körperliche Gesundheit',
    twine: 'Mach die Schnur',
    improve_mobilitiy: 'Körperbeweglichkeit verbessern',
    gear_up: 'stärker werden',
    imprive_condition: 'Verbessern Sie den Zustand',
    get_rid_of_tensions: 'Befreien Sie sich von Spannungen',
    get_rid_of_stress: 'Stress reduzieren',
    relax: 'Ruhe suchen (Entspannung und Meditation hier)',
    be_young: 'Jugend bewahren',
  },
  PRIVACY_POLICY_PAGE: {
    section_1: {
      title: '1. Allgemeine Bestimmungen',
      content: `<ol> <li> Verantwortliche Stelle für personenbezogene Daten ist StretchMe Sp. z o.o. mit Sitz in Krakau, ul. Lubomirskiego 20, 31-509 Krakau, eingetragen im Handelsregister des Bezirksgerichts für Krakau-Śródmieście in Krakau, 11. Wirtschaftsabteilung des Nationalen Gerichtsregisters unter der Nummer KRS 0000881960, Steuernummer (NIP) 5213919480, statistische Nummer (REGON) 388143664, Stammkapital in Höhe von 10.000,00 polnischen Zloty (nachfolgend "der <strong>Verantwortliche</strong>"). </li> <li> Personenbezogene Daten von Personen, die die Anwendung des Verantwortlichen (nachfolgend "Anwendung") oder die von dem Verantwortlichen erbrachten Dienstleistungen (nachfolgend "<strong>Dienstleistung</strong>") nutzen (nachfolgend "<strong>Benutzer</strong>"), werden gemäß den Bestimmungen der Verordnung (EU) 2016/679 des Europäischen Parlaments und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der Verarbeitung personenbezogener Daten und zum freien Datenverkehr (nachfolgend "DSGVO") sowie den Bestimmungen des polnischen Datenschutzgesetzes, der Durchführungsverordnungen zu diesem Gesetz und dem Gesetz über die Erbringung von Dienstleistungen auf elektronischem Wege vom 18. Juli 2002 (ABl. 2002, Nr. 144, Pos. 1204, geändert) verarbeitet. </li> <li> Personenbezogene Daten sind alle Informationen über eine identifizierte oder identifizierbare natürliche Person. Eine identifizierbare Person ist eine Person, die direkt oder indirekt identifiziert werden kann, insbesondere anhand eines Identifikators wie Vorname und Nachname, E-Mail-Adresse, Identifikationsnummer, Standortdaten, Internetkennung oder einer oder mehrerer besonderer Faktoren, die die physische, physiologische, genetische, psychische, wirtschaftliche, kulturelle oder soziale Identität einer natürlichen Person bestimmen. </li> <li> Die Verarbeitung personenbezogener Daten umfasst grundsätzlich jede Handlung, die an personenbezogenen Daten vorgenommen wird, unabhängig davon, ob sie automatisiert oder nicht automatisiert erfolgt, einschließlich Sammlung, Speicherung, Aufbewahrung, Organisation, Änderung, Einsichtnahme, Nutzung, Weitergabe, Einschränkung, Löschung oder Vernichtung. </li> <li> Der Verantwortliche bittet die Benutzer, die Datenschutzrichtlinie sorgfältig zu lesen, bevor sie die Anwendung oder die Dienstleistungen nutzen. </li> <li> Das Herunterladen, die Installation und die Nutzung der Anwendung bedeutet, dass derBenutzer der Erhebung, Verwendung und Übermittlung personenbezogener Daten des Benutzers gemäß den Bestimmungen dieser Datenschutzrichtlinie zustimmt. Wenn der Benutzer sich dafür entscheidet, dem Verantwortlichen seine personenbezogenen Daten nicht zur Verfügung zu stellen, kann der Benutzer die Dienstleistungen nicht vollständig nutzen. </li> </ol>`,
    },
    section_2: {
      title: 'II. LEGAL BASIS FOR DATA PROCESSING',
      content: `<ol> <li> The legal basis for processing personal data by the Controller for the following purposes: <ol> <li> creation of a User account is Art. 6(1)(a) of the General Data Protection Regulation (GDPR), which is the User's consent to the processing of data; </li> <li> performance of activities aimed at concluding and executing the Service is Art. 6(1)(b) of the GDPR, which involves taking actions necessary to conclude an agreement for the provision of the Service and the need for its performance by the Controller for the User concerned; </li> <li> provision of the Service concerning biometric data (activity and physical fitness characteristics and image) and health data is Art. 9(2)(a) of the GDPR, which is the User's explicit consent to the processing of data, and Art. 9(2)(f) of the GDPR, which states that processing is necessary for establishing, pursuing, or defending legal claims by the Controller; </li> <li> subscription to the Controller's newsletter is Art. 6(1)(a) of the GDPR, which is the User's explicit consent to the processing of data; </li> <li> consent to the collection of location data using the functionality of User's mobile devices is Art. 6(1)(a) of the GDPR, which is the User's consent to the processing of data; </li> <li> fulfilling the legal obligations incumbent on the Controller is Art. 6(1)(c) of the GDPR, which involves the performance of obligations resulting from legal provisions concerning the Controller's activities, in particular based on accounting and tax regulations; </li> <li> necessary for the legitimate interests pursued by the Controller, including conducting marketing activities and advertising campaigns for the Controller's Services electronically or by phone based on separate explicit consent given by the User under Art. 6(1)(a) of the GDPR, which is the User's explicit consent to the processing of such data; </li> <li> necessary for the performance of legally justified interests pursued by the Controller or third parties is Art. 6(1)(f) of the GDPR, which is based on legally justified purposes pursued by the Controller, in particular for establishing, pursuing, or defending legal claims, internal administrative purposes of the Controller, including analysis, statistics, and internal reporting by the Controller. </li> </ol> <li> The Controller processes personal data voluntarily provided by the Users and data collected automatically regarding the use of the Application in accordance with Art. 6(1)(a) of the GDPR, which is the User's consent to the processing of data, and Art. 6(1)(f) of the GDPR, which is based on legally justified purposes pursued by the Controller, in particular for direct marketing of the Controller's Services, as well as for optimizing, improving, and personalizing the functions of the Application and creating statistics. The Controller ensures that such processing does not violate the rights and freedoms of the data subjects. </li> <li> Personal data voluntarily provided by the User is not combined with automatically collected data regarding the User's use of the Application. The Controller informs that for technical reasons, such a connection may occur; however, in such a situation, the data so connected will be processed by the Controller solely due to legally justified purposes pursued by the Controller, in particular for optimizing, improving, and personalizing the functions of the Application and creating statistics for the Controller's internal needs. </li> <li> With separately expressed consent from the User, their personal data may be processed for the purpose of sending commercial information about the Controller's Services electronically. The User has the right to request the cessation of sending commercial information electronically or to cease using their phone number for direct marketing purposes at any time. </li> <li> Personal data of Users will be processed for the period necessary to achieve the above-mentioned purposes of processing, i.e.: <ol> <li> in the case of User's consent - until its withdrawal; </li> <li> in terms of activities aimed at concluding and executing the Service at the User's request - until their completion, and after that time - to the extent necessary for establishing, pursuing, or defending legal claims related to these activities - until the expiration of the limitation period for these claims as specified by the law; </li> <li> in terms of the performance of the Service at the User's request - until their completion, and after that time - to the extent necessary for establishing, pursuing, or defending legal claims related to these activities - until the expiration of the limitation period for these claims as specified by the law; </li> <li> in terms of fulfilling legal obligations incumbent on the Controller in connection with conducting business activities and providing the Services - for the periods indicated in the relevant legal provisions concerning the Controller's business activities, in particular: <ol type="a"> <li> for tax documentation - for a period of 5 years counting from the end of the calendar year in which the tax payment deadline expired, </li> <li> for accounting documentation - for a period of 5 years counting from the end of the calendar year in which the operations, transactions, and proceedings were finally concluded, paid, settled, or expired; </li> </ol> </li> <li> in the case of processing for purposes arising from the legally justified interests pursued by the Controller or third parties - until their implementation or until the User objects to such processing, unless there are legally justified grounds for further processing of the User's data by the Controller; </li> <li> in the case of processing for marketing purposes by the Controller electronically or by phone, they will be processed until the relevant consents are withdrawn; </li> <li> in terms of information necessary for handling complaints, they will be processed until the expiration of the rights in this regard; </li> <li> in the case of processing for archival purposes, they will be processed for 3 years from the end of the provision of the Services. </li> </ol> </li> </li> </ol>`,
    },
    section_3: {
      title: '',
      content: '',
    },
    section_4: {
      title: '',
      content: '',
    },
    section_5: {
      title: '',
      content: '',
    },
    section_6: {
      title: '',
      content: '',
    },
  },
  STRIPE_GATE: {
    title: 'Important Subscription Information',
    content:
      "Thank you for choosing PhysioStretch! Please note that when you purchase a subscription on our website, it is a one-time payment and will not automatically renew. To enable automatic renewals, you'll need to manage your subscription through our mobile app. If you continue purchasing through the website, you'll need to manually repurchase access each time your subscription expires. For a seamless experience, we recommend using our mobile app to manage renewals.",
    button: 'Purchase One-Time Access',
    payment_success: 'Payment completed successfully. Click here to continue.',
    payment_failed: 'Payment failed.',
    payment: 'Continue',
    processing: 'Processing payment...',
    '1_m_p': '1 Month PhysioStretch',
    '3_m_p': '3 Months PhysioStretch',
    '1_r_p': '1 Year PhysioStretch',
    go_back: 'Go back',
    retry_payment: 'Retry payment',
    waiting_refresh: 'Wait a moment, then refresh the page.',
  },
};
